import React, {
  useRef,
  useContext,
  useEffect,
  useState,
  useImperativeHandle,
  useCallback,
} from "react";
import AddNewItem from "./AddNewItem";
import ItemWiseBatchList from "./ItemWiseBatchList";
import TransactionTypeSettingAPI from "../../API/APIServices/TransactionTypeSetting";
import TaxCategoryApi from "../../API/APIServices/TaxCategory";
import SaleItemAddPageComponent from "./SaleItemAddPageComponent";
import Transaction from "../../API/APIServices/Transaction";
import MyContext from "../MyContext";
import Account from "../../API/APIServices/Account";
import MastersModalBox from "./MastersModalBox";
import LensitemDataModal from "../LensTransaction/LensitemDataModal";
import ThemeModalFristComponent from "./Dropdown/ThemeModalFristComponent";
import Swal from "sweetalert2";
import CsvModalSaleInvoice from "../Utilities/ReportSetting/CsvModalSaleInvoice";

function ProductList(props) {
  /************Category box****************/
  const {
    PreviousPage,
    NextPage,
    pageNo,
    setPageNo,
    setItemPerPage,
    ItemPerPage,
    inputValues,
    setInputValues,
    mainPageInputRef,
    itemMasterRows,
    setItemMasterRows,
    handlesGSTCalculation,
    GetProductDataFunction,
    sundryRows,
    ShowMainProductOnlyInItemSuggestion,
    ShowCostPriceAndLandingPrice,
    onChangeProductSaveMethod,
    ReferenceNumber,
    // itemRefs,
    nextCellRefsProduct,
    currencyDecimalPlaces,
    PopUpSerialOpen,
    setLoading,
    setModalOpen,
    openGroupModal,
    BatchNoData,
    setBatchNoData,
    enableBatchNoEntry,
    ProductOpnedInPopup,
    inputRefs,
    setChangeInData,
    ChangeInData,
    stockQuantity,
    fetchItemStock,
    TransAccountId,
    setApiCallProductAllowed,
    enableBarcodeGeneration,
    openItemUploadCSV,
    setOpenItemUploadCSV,
    allSettings,
    PowerRangeADD,
    PowerRangeCYL,
    PowerRangeAXIS,
    PowerRangeSPH,
    PowerRangeEYE,
    setPowerRangeADD,
    setPowerRangeCYL,
    setPowerRangeAXIS,
    setPowerRangeSPH,
    setPowerRangeEYE,
  } = props;

  const { Offescpback, setOffescback } = useContext(MyContext);
  const [Code, setCode] = useState(0);

  const GenerateCode = () => {
    const CodeNew = Math.floor(100000 + Math.random() * 900000);
    setCode(CodeNew);
    return CodeNew;
  };

  useEffect(() => {
    GenerateCode();
  }, []);

  useEffect(() => {
    console.log("Code1", Code);
  }, [Code]);

  const { debounce } = useContext(MyContext);

  useEffect(() => {
    console.log(itemMasterRows);
    console.log(currencyDecimalPlaces);
  }, [itemMasterRows]);

  useImperativeHandle(mainPageInputRef, () => ({
    hideModal3,
  }));

  // const [PowerRange, setPowerRange] = useState({});

  // useEffect to update state arrays based on itemMasterRows length

  // const [PowerRangeCYLShow, setPowerRangeCYLShow] = useState(false);
  // const [PowerRangeADDShow, setPowerRangeADDShow] = useState(false);
  // const [PowerRangeAXISShow, setPowerRangeAXISShow] = useState(false);
  // const [PowerRangeSPHShow, setPowerRangeSPHShow] = useState(false);

  const ChangeItemPerPage = (e) => {
    setItemPerPage(e.target.value);
  };

  const suggestionBoxRef = useRef(null);
  const itemRefs = useRef([]); // Reference for each list item

  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  useEffect(() => {
    if (
      highlightedIndex >= 0 &&
      itemRefs.current[highlightedIndex] &&
      suggestionBoxRef.current
    ) {
      itemRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
    console.log(highlightedIndex);
  }, [highlightedIndex]);

  let TransType = inputValues.TransType;
  let TransName = inputValues.TransName;

  const [headingValue, setHeadingValue] = useState([]);
  const [inputPosition, setInputPosition] = useState({
    top: 0,
    left: 0,
    width: 80,
  });
  useEffect(() => {
    console.log(inputPosition);
  }, [inputPosition]);

  const RemoveSuggestion = (rowIndex) => {
    setTimeout(() => {
      setItemMasterList((prevRows) => {
        if (!Array.isArray(prevRows) || !prevRows[rowIndex]) return prevRows;

        const newRows = [...prevRows];
        newRows[rowIndex] = {
          ...newRows[rowIndex],
          isDropdownOpen: false,
          filteredProduct: [],
        };
        return newRows;
      });
    }, 400);
  };

  const getPosition = (rowIndex, columnIndex) => {
    setTimeout(() => {
      const shouldOpenDropdown = (list) => {
        if (!Array.isArray(list)) return false;
        if (list.length > 1) return true;
        if (list.length === 1 && list[0] != 0) return true;
        return false;
      };

      if (columnIndex === 8) {
        setPowerRangeSPH((prevState) => {
          const list = prevState[rowIndex]?.PowerRangeSPHList ?? [];
          if (!shouldOpenDropdown(list)) return prevState;

          const updatedState = [...prevState];
          updatedState[rowIndex] = {
            ...updatedState[rowIndex],
            PowerRangeSPHShow: true,
          };
          return updatedState;
        });
      } else if (columnIndex === 9) {
        setPowerRangeCYL((prevState) => {
          const list = prevState[rowIndex]?.PowerRangeCYLList ?? [];
          if (!shouldOpenDropdown(list)) return prevState;

          const updatedState = [...prevState];
          updatedState[rowIndex] = {
            ...updatedState[rowIndex],
            PowerRangeCYLShow: true,
          };
          return updatedState;
        });
      } else if (columnIndex === 10) {
        setPowerRangeAXIS((prevState) => {
          const list = prevState[rowIndex]?.PowerRangeAXISList ?? [];
          if (!shouldOpenDropdown(list)) return prevState;

          const updatedState = [...prevState];
          updatedState[rowIndex] = {
            ...updatedState[rowIndex],
            PowerRangeAXISShow: true,
          };
          return updatedState;
        });
      } else if (columnIndex === 11) {
        setPowerRangeADD((prevState) => {
          const list = prevState[rowIndex]?.PowerRangeADDList ?? [];
          if (!shouldOpenDropdown(list)) return prevState;

          const updatedState = [...prevState];
          updatedState[rowIndex] = {
            ...updatedState[rowIndex],
            PowerRangeADDShow: true,
          };
          return updatedState;
        });
      } else if (columnIndex === 7) {
        setPowerRangeEYE((prevState) => {
          const list = prevState[rowIndex]?.PowerRangeEYEList ?? [];
          if (!shouldOpenDropdown(list)) return prevState;

          const updatedState = [...prevState];
          updatedState[rowIndex] = {
            ...updatedState[rowIndex],
            PowerRangeEYEShow: true,
          };
          return updatedState;
        });
      }
    }, 300);

    console.log(columnIndex);

    const inputRef = nextCellRefsProduct.current[rowIndex]?.[columnIndex];
    if (inputRef) {
      const rect = inputRef.getBoundingClientRect();
      setInputPosition({
        top: rect.bottom,
        left: rect.left,
        width: rect.width,
      });
    }
  };

  const closeSuggestionAll = async (e, rowIndex1, rowIndex) => {
    let isValid = true;
    const { name, value } = e.target;
    const checkValue = value;

    setTimeout(() => {
      setPowerRangeSPH((prevState) => {
        const updatedState = [...prevState];
        updatedState[rowIndex] = {
          ...updatedState[rowIndex], // Preserve all previous values, including PowerRangeSPHList
          PowerRangeSPHShow: false, // Update only PowerRangeSPHShow
        };
        return updatedState;
      });
      setPowerRangeCYL((prevState) => {
        const updatedState = [...prevState];
        updatedState[rowIndex] = {
          ...updatedState[rowIndex], // Preserve all previous values, including PowerRangeCYLList
          PowerRangeCYLShow: false, // Update only PowerRangeCYLShow
        };
        return updatedState;
      });
      setPowerRangeAXIS((prevState) => {
        const updatedState = [...prevState];
        updatedState[rowIndex] = {
          ...updatedState[rowIndex], // Preserve all previous values, including PowerRangeAXISList
          PowerRangeAXISShow: false, // Update only PowerRangeAXISShow
        };
        return updatedState;
      });
      setPowerRangeADD((prevState) => {
        const updatedState = [...prevState];
        updatedState[rowIndex] = {
          ...updatedState[rowIndex], // Preserve all previous values, including PowerRangeADDList
          PowerRangeADDShow: false, // Update only PowerRangeADDShow
        };
        return updatedState;
      });
      setPowerRangeEYE((prevState) => {
        const updatedState = [...prevState];
        updatedState[rowIndex] = {
          ...updatedState[rowIndex], // Preserve all previous values, including PowerRangeADDList
          PowerRangeEYEShow: false, // Update only PowerRangeADDShow
        };
        return updatedState;
      });
    }, 200);

    if (
      checkValue === undefined ||
      checkValue === null ||
      (typeof checkValue === "string" && checkValue.trim() === "") ||
      isNaN(Number(checkValue))
    ) {
      return;
    }

    const powerRangeMap = {
      lens_SPH: PowerRangeSPH,
      lens_CYL: PowerRangeCYL,
      lens_AXIS: PowerRangeAXIS,
      lens_Add: PowerRangeADD,
      lens_Eye: PowerRangeEYE, // optional if needed
    };

    const listKeyMap = {
      lens_SPH: "PowerRangeSPHList",
      lens_CYL: "PowerRangeCYLList",
      lens_AXIS: "PowerRangeAXISList",
      lens_Add: "PowerRangeADDList",
      lens_Eye: "PowerRangeEYEList",
    };

    if (name in powerRangeMap) {
      const rangeList =
        powerRangeMap[name]?.[rowIndex]?.[listKeyMap[name]] || [];

      // Convert both sides to string with fixed decimal (for consistency)
      const normalizedValue = parseFloat(checkValue).toFixed(2);

      const normalizedList = rangeList.map((v) => parseFloat(v).toFixed(2));

      if (!normalizedList.includes(normalizedValue)) {
        alert(`Value ${checkValue} is not in allowed list for ${name}.`);
        setItemMasterRows((prevRows) => {
          const newRows = [...prevRows];
          newRows[rowIndex] = {
            ...newRows[rowIndex],
            [name]: "",
          };

          updateTotals(newRows);

          return newRows;
        });

        isValid = false;
      } else {
        if (ChangeInData) {
          SearchItemAndChangeItem(rowIndex, checkValue, name, rowIndex1, e);
        }
      }
    }
  };

  // const [PowerRangeEYE, setPowerRangeEYE] = useState({});
  useEffect(() => {
    console.log("lensData", PowerRangeADD);
    console.log("lensData", PowerRangeCYL);
    console.log("lensData", PowerRangeSPH);
    console.log("lensData", PowerRangeAXIS);
  }, [PowerRangeADD, PowerRangeCYL, PowerRangeAXIS, PowerRangeSPH]);

  const handlePowerSelection = async (
    e,
    rowindex,
    item,
    name,
    value,
    rowIndex1
  ) => {
    ;
    let isValid = true;
    const checkValue = value;

    if (checkValue === undefined) {
      return;
    }

    const saveWhenValid = async () => {
      if (isValid) {
        await setItemMasterRows((prevRows) => {
          const newRows = [...prevRows];
          newRows[rowindex] = {
            ...newRows[rowindex],
            [name]: value,
          };
          updateTotals(newRows);
          return newRows;
        });
        setHighlightedIndex7(-1);
        setHighlightedIndex8(-1);
        setHighlightedIndex9(-1);
        setHighlightedIndex10(-1);
        setHighlightedIndex11(-1);
      }
    };

    if (
      name === "lens_Eye" ||
      name === "lens_SPH" ||
      name === "lens_CYL" ||
      name === "lens_AXIS" ||
      name === "lens_Add"
    ) {
      if (name === "lens_Add") {
        const minValue = ProductRangeDataMain?.add_Min || -10;
        const maxValue = ProductRangeDataMain?.add_Max || 10;

        if (checkValue < minValue || checkValue > maxValue) {
          alert(
            `Value ${checkValue} is out of range! It must be between ${minValue} and ${maxValue}.`
          );
          isValid = false;
        } else {
          SearchItemAndChangeItem(rowindex, checkValue, name, rowIndex1, e);
          saveWhenValid();
        }
      } else if (name === "lens_SPH") {
        const minValue = ProductRangeDataMain?.sph_min || -10;
        const maxValue = ProductRangeDataMain?.sph_max || 10;

        if (checkValue < minValue || checkValue > maxValue) {
          alert(
            `Value ${checkValue} is out of range! It must be between ${minValue} and ${maxValue}.`
          );
          isValid = false;
        } else {
          SearchItemAndChangeItem(rowindex, checkValue, name, rowIndex1, e);
          saveWhenValid();
        }
      } else if (name === "lens_CYL") {
        console.log(PowerRangeCYL);
        const minValue = ProductRangeDataMain?.cyl_min || -10;
        const maxValue = ProductRangeDataMain?.cyl_max || 10;

        if (checkValue < minValue || checkValue > maxValue) {
          alert(
            `Value ${checkValue} is out of range! It must be between ${minValue} and ${maxValue}.`
          );
          isValid = false;
        } else {
          SearchItemAndChangeItem(rowindex, checkValue, name, rowIndex1, e);
          saveWhenValid();
        }
      } else if (name === "lens_AXIS") {
        const minValue = 0;
        const maxValue = 180;

        if (checkValue < minValue || checkValue > maxValue) {
          alert(
            `Value ${checkValue} is out of range! It must be between ${minValue} and ${maxValue}.`
          );
          isValid = false;
        } else {
          SearchItemAndChangeItem(rowindex, checkValue, name, rowIndex1, e);
          saveWhenValid();
        }
      } else if (name === "lens_Eye") {
        const allowedValues = ["R", "L", "RL", ""];

        if (!allowedValues.includes(checkValue)) {
          alert(`Invalid value for lens_Eye! It must be one of: R, L, RL.`);
          await setItemMasterRows((prevRows) => {
            const newRows = [...prevRows];
            newRows[rowindex] = {
              ...newRows[rowindex],
              [name]: "R",
            };
            updateTotals(newRows);
            return newRows;
          });
          setHighlightedIndex7(-1);
          setHighlightedIndex8(-1);
          setHighlightedIndex9(-1);
          setHighlightedIndex10(-1);
          setHighlightedIndex11(-1);
          isValid = false;
        } else {
          console.log(`Value for lens_Eye is ${checkValue}`);
          SearchItemAndChangeItem(rowindex, checkValue, name, rowIndex1, e);
          saveWhenValid();
        }
      }
    }
  };

  const SearchItemAndChangeItem = async (
    rowIndex,
    checkValue,
    name,
    rowIndex1,
    e
  ) => {
    ;
    var getRowData = itemMasterRows[rowIndex];

    const filterData = {
      searchTypeId: 5,
      itmId_d2: getRowData.d2_Id,
      // itmId_d2: 10115,
    };

    // Create a copy and override the specific field
    const updatedRowData = { ...getRowData, [name]: checkValue };

    if (
      updatedRowData.lens_AXIS !== undefined &&
      updatedRowData.lens_AXIS !== null &&
      Number(updatedRowData.lens_AXIS) != 0
    ) {
      filterData.axis = Number(updatedRowData.lens_AXIS);
    }

    if (
      updatedRowData.lens_Add !== undefined &&
      updatedRowData.lens_Add !== null &&
      Number(updatedRowData.lens_Add) != 0
    ) {
      filterData.add = Number(updatedRowData.lens_Add);
    }

    if (
      updatedRowData.lens_CYL !== undefined &&
      updatedRowData.lens_CYL !== null &&
      updatedRowData.lens_CYL !== ""
    ) {
      filterData.cyl = Number(updatedRowData.lens_CYL);
    }

    if (
      updatedRowData.lens_SPH !== undefined &&
      updatedRowData.lens_SPH !== null &&
      updatedRowData.lens_SPH !== ""
    ) {
      filterData.sph = Number(updatedRowData.lens_SPH);
    }

    if (updatedRowData.lens_Eye) {
      filterData.eye = updatedRowData.lens_Eye;
    }

    const ItemData = await Transaction.GetBarcodeSerialBatchNoForItemFetch(
      filterData
    );

    ;
    if (ItemData && Object.keys(ItemData).length > 0) {
      setChangeInData(true);
      let newrows = [];

      setItemMasterRows((prevRows) => {
        const newRows = [...prevRows];
        newRows[rowIndex] = {
          ...newRows[rowIndex],
          // rowIndex : ItemData.rowIndex,
          d1_Id: ItemData.d1_Id || "",
          d2_Id: ItemData.d2_Id || "",
          productName: ItemData.productName || "",
          parentGrp: ItemData.parentGrp2 || "",
          parentGrpName: ItemData.parentGrpName || "",
          productUnitName: ItemData.productUnitName || "",
          productUnit: ItemData.productUnit || "",
          productAltUnit: ItemData.productAltUnit || "",
          unitConvFactor: ItemData.unitConvFactor || "",
          enableBarcode: ItemData.enableBarcode || "",
          defaultBarcode: ItemData.Barcode || "",
          batchNos: ItemData.batchDetails || [],
          taxCategory1: ItemData.taxCategory1 || "",
          taxLimit: ItemData.taxLimit || "",
          taxCategory2: ItemData.taxCategory2 || "",
          hsnCode: ItemData.hsnCode || "",
          shortDescription: "",
          Qty: ItemData.Qty === 0 ? 1 : ItemData.Qty || 1,
          FreeQty: ItemData.FreeQty || "",
          purchasePrice: ItemData.purchasePrice || "",
          purchaseDiscount: ItemData.purchaseDiscount || "",
          saleProfit: ItemData.saleProfit || "",
          salePrice: ItemData.salePrice || "",
          saleDiscount: ItemData.saleDiscount || "",
          itemPrice:
            Number(TransAccountId) === 216
              ? ItemData.salePrice
              : Number(TransAccountId) === 215
              ? ItemData.purchasePrice
              : ItemData.salePrice,

          costPrice: ItemData.costPrice || "",
          mrpPrice: ItemData.mrpPrice || "",
          DiscPer:
            Number(TransAccountId) === 216
              ? ItemData.saleDiscount
              : Number(TransAccountId) === 215
              ? ItemData.purchaseDiscount
              : ItemData.saleDiscount,
          DiscAmt: ItemData.DiscAmt || "",
          TotalAmt: ItemData.TotalAmt || "",
          // salePriceForPur: ItemData.salePriceForPur || 0,
          purPageSalePrice: ItemData.salePrice || "",
          availableQuantity: ItemData.availableQuantity || "",
          lens_Eye: (ItemData?.lens_Eye || "").split(",")[0] || "",
          lens_SPH:
            ItemData.lens_Eye != null
              ? ItemData.lens_SPH
                ? parseFloat(ItemData.lens_SPH).toFixed(2)
                : ""
              : "",
          lens_CYL:
            ItemData.lens_Eye != null
              ? ItemData.lens_CYL
                ? parseFloat(ItemData.lens_CYL).toFixed(2)
                : ""
              : "",

          lens_AXIS:
            ItemData.lens_AXIS && ItemData.lens_AXIS !== 0
              ? ItemData.lens_AXIS
              : "",
          lens_Dia:
            ItemData.lens_Dia && ItemData.lens_Dia !== 0
              ? ItemData.lens_Dia
              : "",
          lens_Add:
            ItemData.lens_Add && ItemData.lens_Add !== 0
              ? ItemData.lens_Add.toFixed(2)
              : "",

          enableSerialNo: ItemData.enableSerialNo || "",
          taxCat1_Cgst: ItemData.taxCat1_Cgst || "",
          taxCat1_Sgst: ItemData.taxCat1_Sgst || "",
          taxCat1_Igst: ItemData.taxCat1_Igst || "",
          taxCat1_Cess: ItemData.taxCat1_Cess || "",
          taxLimit: ItemData.taxLimit || "",
          taxCategory2: ItemData.taxCategory2 || "",
          taxCat2_Cgst: ItemData.taxCat2_Cgst || "",
          taxCat2_Sgst: ItemData.taxCat2_Sgst || "",
          taxCat2_Igst: ItemData.taxCat2_Igst || "",
          taxCat2_Cess: ItemData.taxCat2_Cess || "",
          masterDescription: Code,
          LensTypeEf: ItemData.LensTypeEf || "",
        };
        newrows = newRows;
        return newRows;
      });

      const PowerRangeData = {
        add_min: ItemData.add_min || "",
        add_max: ItemData.add_max || "",
        add_step: ItemData.add_step || "",
        cyl_min: ItemData.cyl_min || "",
        cyl_max: ItemData.cyl_max || "",
        cyl_step: ItemData.cyl_step || "",
        sph_min: ItemData.sph_min || "",
        sph_max: ItemData.sph_max || "",
        sph_step: ItemData.sph_step || "",
        Eye: ItemData.Eye || "",
      };

      setProductRangeDataMain(PowerRangeData);
      // ;
      if (PowerRangeData.cyl_max != "" && PowerRangeData.sph_max != "") {
        if (PowerRangeData) {
          // Generate values for each list based on PowerRangeData
          const values1 = [];
          for (
            let i = parseFloat(PowerRangeData.add_min);
            i <= parseFloat(PowerRangeData.add_max);
            i += parseFloat(PowerRangeData.add_step)
          ) {
            values1.push(i);
          }

          const values2 = [];
          for (
            let i = parseFloat(PowerRangeData.cyl_min);
            i <= parseFloat(PowerRangeData.cyl_max);
            i += parseFloat(PowerRangeData.cyl_step)
          ) {
            values2.push(i);
          }

          const values3 = [];
          for (
            let i = parseFloat(PowerRangeData.sph_min);
            i <= parseFloat(PowerRangeData.sph_max);
            i += parseFloat(PowerRangeData.sph_step)
          ) {
            values3.push(i);
          }

          const axis = ItemData.axis;
          const axisValues = axis.split(",").map(Number); // Convert "45,90,180" into an array of numbers [45, 90, 180]

          const values4 = [];

          // Loop through each value in axisValues
          for (let value of axisValues) {
            values4.push(value); // You can perform other operations with 'value' inside the loop if needed
          }

          const EYE = PowerRangeData.Eye || "R,L,RL";
          const EyeValues = EYE.split(","); // Split the string into an array of ["R", "L", "RL"]
          // Create the values5 array directly by using map
          const values5 = EyeValues.map((eye) => {
            // Optional: You could add transformations here if needed
            return eye; // Since you seem to want to keep the values the same, just return the value
          });

          console.log(values5); // Output: ["R", "L", "RL"]

          // Update the specific row in the state arrays
          setPowerRangeADD((prevState) => {
            if (values1.length > 0) {
              const updatedState = [...prevState];
              updatedState[rowIndex] = {
                PowerRangeADDShow: false,
                PowerRangeADDList: values1,
              };
              return updatedState;
            }
            return prevState;
          });

          setPowerRangeCYL((prevState) => {
            if (values2.length > 0) {
              const updatedState = [...prevState];
              updatedState[rowIndex] = {
                PowerRangeCYLShow: false,
                PowerRangeCYLList: values2,
              };
              return updatedState;
            }
            return prevState;
          });

          setPowerRangeSPH((prevState) => {
            if (values3.length > 0) {
              const updatedState = [...prevState];
              updatedState[rowIndex] = {
                PowerRangeSPHShow: false,
                PowerRangeSPHList: values3,
              };
              return updatedState;
            }
            return prevState;
          });

          setPowerRangeAXIS((prevState) => {
            if (values4.length > 0) {
              const updatedState = [...prevState];
              updatedState[rowIndex] = {
                PowerRangeAXISShow: false,
                PowerRangeAXISList: values4,
              };
              return updatedState;
            }
            return prevState;
          });

          setPowerRangeEYE((prevState) => {
            if (values5.length > 0) {
              const updatedState = [...prevState];
              updatedState[rowIndex] = {
                PowerRangeEYEShow: false,
                PowerRangeEYEList: values5,
              };
              return updatedState;
            }
            return prevState;
          });
        }
      }

      setTimeout(async () => {
        await onChangeProductSaveMethod(
          e,
          rowIndex1,
          rowIndex,
          "",
          newrows,
          true
        );
      }, 10);
    } else {
      // Remove defaultBarcode from the specific row
      setItemMasterRows((prevRows) => {
        const updatedRows = [...prevRows];
        if (updatedRows[rowIndex]) {
          updatedRows[rowIndex] = {
            ...updatedRows[rowIndex],
            defaultBarcode: "", // Clear the defaultBarcode
            d1_Id: "",
            // d2_Id: "",
            [name]: "",
          };
        }
        return updatedRows;
      });

      Swal.fire({
        title: "No product Found",
        text: "No product Found for this range",
        icon: "warning",
        width: "350px",
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar: true,
        customClass: {
          title: "swal2-custom-title",
          confirmButton: "my-confirm-button",
          cancelButton: "my-cancel-button",
          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
    }
  };

  // const handlePowerSelection = async (rowindex, item, name, value) => {
  //   // ;

  //   await setItemMasterRows((prevRows) => {
  //     const newRows = [...prevRows];
  //     if (item !== "" || item !== undefined || item != []) {
  //       newRows[rowindex] = {
  //         ...newRows[rowindex],
  //         [name]: item,
  //       };
  //     } else {
  //       newRows[rowindex] = {
  //         ...newRows[rowindex],
  //         [name]: value, // Set the provided `value` if `item` is empty or undefined
  //       };
  //     }

  //     updateTotals(newRows);
  //     return newRows;
  //   });
  // };

  // useEffect(() => {
  //   console.log(PowerRange);

  // }, [PowerRange]);

  /************modal box************/

  const [isModalOpen3, setModalOpen3] = useState(false);

  const showModal3 = () => {
    setOffescback(2);
    setModalOpen3(true);
    setModalOpen(true);
  };

  const hideModal3 = () => {
    setModalOpen3(false);
    setModalOpen(false);
  };

  const [AddNewModal, setNewModal] = useState(false);

  const openAddItemModal = () => {
    setNewModal(true);
  };

  const closeAddItemModal = () => {
    setNewModal(false);
  };
  /*****************************************/

  const [customfields, setCustomefields] = useState([]);
  console.log('customfields',customfields);

  const customFieldAddBtn = () => {
    const val = document.getElementById("CustomFieldInput").value;
    console.log(val);
    if (val.trim() !== "") {
      const newData = { id: customfields.length + 1, FieldName: val };
      setCustomefields([...customfields, newData]);
      document.getElementById("inputField").style.display = "none";
      document.getElementById("CustomFieldInput").value = "";
    } else {
      alert("Please Enter valid Name", "ok");
    }
  };

  const AddCustmField_clicked = () => {
    document.getElementById("inputField").style.display = "block";
  };

  /************************{modal box}************************/

  const appendValue = (e) => {
    console.log(e.target.value);
    let newItem = [...headingValue, e.target.value];
    setHeadingValue(newItem);
  };
  useEffect(() => {
    let savedItems = JSON.parse(localStorage.getItem("headValue"));
    if (savedItems) {
      setHeadingValue(savedItems);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("headValue", JSON.stringify(headingValue));
  }, [headingValue]);

  const [sampleData, setSampleData] = useState([]);

  const generateData = (count) => {
    return Array.from({ length: count }, (_, index) => ({ id: index + 1 }));
  };
  // Example function to update the data dynamically
  const updateData = () => {
    setSampleData(generateData(100)); // Generate data for 100 items
  };

  // const [dynamicHeight, setDynamicHeight] = useState(auto);

  // const updateHeight = (val) => {
  //     const newHeight = val;
  //     setDynamicHeight(newHeight);
  // };

  const [SaleItemAddPage, setSaleItemAddPage] = useState(false);
  const [lensPowerModalOpen, setLensPowerModalOpen] = useState(false);
  const [LensPowerItem, setLensPowerItem] = useState({});
  const [LensPowerItemRowindex, setLensPowerItemRowindex] = useState();

  const lensPowerModal = (item, rowindex) => {
    if (item.parentGrpName == "") return;
    setOffescback(2);
    setLensPowerItem(item);
    setLensPowerModalOpen(true);
    setLensPowerItemRowindex(rowindex);
    // setTimeout(() => {
    //   handleDeleteRow(index , rowindex)
    // }, 1000);
  };

  const closeLensPowerModal = () => {
    setLensPowerModalOpen(false);
  };

  const SaleItemAdd = (edit) => {
    // // ;
    // setIndexToEdit(null);
    if (itemMasterRows[0].productName != "") {
      if (edit !== "edit") {
        handleAddRow();
      }
    }
    setSaleItemAddPage(true);
  };

  const CloswSaleItemAdd = () => {
    setIndexToEdit(null);
    setSaleItemAddPage(false);
  };

  const addRowAtBetween = (index) => {
    const newId = index + 1;
    const newRow = {
      id: newId,
    };

    const updatedTableData = sampleData.map((row, i) => ({
      ...row,
      id: i >= index ? row.id + 1 : row.id,
    }));

    updatedTableData.splice(index, 0, newRow);

    setSampleData(updatedTableData);
  };

  const [hoveredRow, setHoveredRow] = useState(null);

  const handleRowHover = (index) => {
    setHoveredRow(index);
  };

  const handleRowLeave = () => {
    setHoveredRow(null);
  };

  const deleteValueById = (id) => {
    console.log("hello");
    setCustomefields((prevState) => prevState.filter((item) => item.id !== id));
  };
  const handleModalClick = (e) => {
    // Prevent the event from propagating to parent elements
    e.stopPropagation();
  };

  const [isItemWiseList, setItemWiseList] = useState(false);
  const showModalOpen6 = () => {
    setItemWiseList(true);
  };
  const hideModalOpen61 = () => {
    setItemWiseList(false);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      showModalOpen6();
    }
  };

  /**********************Start From(Shivendra 06062024)**********************/

  //----------------- Show/Hide Column ----------------//

  const [IsExistTransColumnSet, setIsExistTransColumn] = useState(false);
  const [TransColumnSet, setTransColumn] = useState([]);
  const [TransColumnCb, setTransColumnCb] = useState({
    isInputVisible1: false,
    isInputVisible2: false,
    isInputVisible3: true,
    isInputVisible4: false,
    isInputVisible5: false,
    isInputVisible6: false,
    isInputVisible7: false,
    isInputVisible8: false,
    isInputVisible9: false,
    isInputVisible10: false,
    isInputVisible11: false,
    isInputVisible12: false,
    isInputVisible13: false,
    isInputVisible14: false,
    isInputVisible15: false,
    isInputVisible16: false,
    isInputVisible17: false,
    isInputVisible18: false,
    isInputVisible19: false,
    isInputVisible20: false,
    isInputVisible21: false,
    isInputVisible22: true,
    isInputVisible23: false,
    isInputVisible24: true,
    isInputVisible25: false,
    isInputVisible26: false,
    isInputVisible27: false,
    isInputVisible28: true,
    isInputVisible29: false,
    isInputVisible30: false,
    isInputVisible31: false,
    isInputVisible32: false,
    isInputVisible33: false,
    isInputVisible34: false,
    isInputVisible35: false,
    isInputVisible36: false,
    isInputVisible37: false,
    isInputVisible38: false,
    isInputVisible39: false,
    isInputVisible40: false,
  });

  useEffect(() => {
    console.log("IsExistTransColumnSet", IsExistTransColumnSet);
    console.log("TransColumnSet", TransColumnSet);
  }, [IsExistTransColumnSet, TransColumnSet]);

  const [itemMasterList, setItemMasterList] = useState([
    {
      id: 0,
      name: "",
      isDropdownOpen: false,
      highlightedIndex: -1,
      filteredProduct: [],
    },
  ]);

  useEffect(() => {
    console.log("itemMasterListi", itemMasterList);
  }, [itemMasterList]);

  const [itemGroupMasterList, setitemGroupMasterList] = useState([
    {
      id: 0,
      name: "",
      isDropdownOpen: false,
      highlightedIndex: -1,
      filteredProduct: [],
    },
  ]);

  const [UnitList, setUnitList] = useState([
    {
      id: 0,
      name: "",
      isDropdownOpen: false,
      highlightedIndex: -1,
      filteredProduct: [],
    },
  ]);

  useEffect(() => {
    console.log(itemGroupMasterList);
  }, [itemGroupMasterList]);

  useEffect(() => {
    console.log(TransColumnSet);
  }, [TransColumnSet]);

  /*const [itemMasterRows, setItemMasterRows] = useState([{
        d1_Id: 0,
        d2_Id: 0,
        productName: "",
        parentGrp: 0,
        parentGrpName: "",
        productUnit: 0,
        productAltUnit: 0,
        unitConvFactor: 0,
        enableBarcode: true,
        defaultBarcode: null,
        hsnCode: null,
        shortDescription: null,

        taxCategory1: 0,
        taxCat1_Cgst: 0,
        taxCat1_Sgst: 0,
        taxCat1_Igst: 0,
        taxCat1_Cess: 0,
        taxLimit: 0,
        taxCategory2: 0,
        taxCat2_Cgst: 0,
        taxCat2_Sgst: 0,
        taxCat2_Igst: 0,
        taxCat2_Cess: 0,
        
        Qty: 0,
        FreeQty: 0,
        purchasePrice: 0,
        purchaseDiscount: 0,
        saleProfit: 0,
        salePrice: 0,
        saleDiscount: 0,
        itemPrice: 0,
        costPrice: 0,
        mrpPrice: 0,
        DiscPer: 0,
        DoubleDis: 0,
        DiscAmt: 0,
        TotalAmt: 0,
        salePriceForPur: 0,
        availableQuantity: 0,

        iCateRateA: null,
        iCateRateB: null,
        iCateRateC: null,
        iCateRateD: null,
        iCateRateE: null,
        iCateRateF: null,
        iCateRateG: null,
        iCateRateH: null,
        iCateRateI: null,
        iCateRateJ: null,

        loyaltyPoint: null,
        salesManItemIncentive: null,
        BrkrName: null,
        BrkgAmt: null,
        sellerCommision: null,
        isReturnable: null,
        isStockable: null,
        isGoodsService: false,

        lens_Eye: "",
        lens_SPH: null,
        lens_CYL: null,
        lens_AXIS: null,
        lens_Dia: null,
        lens_Add: null,
        
        Attribute1: null,
        Attribute2: null,
        Attribute3: null,
        Attribute4: null,
        Attribute5: null,
        Note1: null,
        Note2: null,
        BatchNo: null,
        MgfDt: null,
        ExpDt: null,

        isAttributeItem: true,
        iAttributeParent: 0,
        batchDetails: [],
        itemOptionalFields: [],
    }]);
    */

  //---------------Fill Column Setting (Load Event)-----------------------

  const fetchAllList = async () => {
    try {
      // ;
      TransactionTypeSettingAPI.GetVoucherWise_ColumnSetting(TransType)
        .then(function (result1) {
          if (result1) {
            if (result1 && Array.isArray(result1)) {
              // Map the API result to the visibility state
              const visibilityState = result1.reduce((acc, column) => {
                acc[`isInputVisible${column.colId}`] = column.colShow;
                // Fetch Extra Column
                if (column.colId > 34) {
                  const newData = {
                    id: column.colId,
                    FieldName: column.colName,
                  };
                  setCustomefields([...customfields, newData]);
                }

                return acc;
              }, {});
              console.log("visibilityState", visibilityState);
              setTransColumnCb(visibilityState);
              setTransColumn(result1);
              if (result1 && result1.length > 0) {
                setIsExistTransColumn(true);
              }
            } else {
              console.error("API returned an unexpected result:", result1);
            }
          } else {
            console.error("API returned undefined result");
          }
        })
        .catch(function (error) {
          console.error("API Error:", error);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAllList();
    updateData();
  }, [TransType]);

  //---------------Product Row Add, Delete-----------------------

  const handleAddRow = () => {
    const newItemRow = {
      rowIndex: 0,
      d1_Id: 0,
      d2_Id: 0,
      productName: "",
      parentGrp: null,
      parentGrpName: "",
      productUnit: null,
      productAltUnit: null,
      unitConvFactor: null,
      enableBarcode: true,
      defaultBarcode: "",
      taxCategory1: null,
      taxLimit: null,
      taxCategory2: null,
      hsnCode: "",
      shortDescription: "",

      Qty: null,
      FreeQty: null,
      purchasePrice: null,
      purchaseDiscount: null,
      saleProfit: null,
      salePrice: null,
      saleDiscount: null,
      itemPrice: null,
      costPrice: null,
      mrpPrice: null,
      DiscPer: null,
      DoubleDis: null,
      DiscAmt: null,
      totalDisc_With_sundry: null,
      itemWiseTaxbleAmt: null,
      TotalAmt: null,
      salePriceForPur: null,
      availableQuantity: null,

      iCateRateA: null,
      iCateRateB: null,
      iCateRateC: null,
      iCateRateD: null,
      iCateRateE: null,
      iCateRateF: null,
      iCateRateG: null,
      iCateRateH: null,
      iCateRateI: null,
      iCateRateJ: null,

      loyaltyPoint: null,
      salesManItemIncentive: null,
      BrkrName: null,
      BrkgAmt: null,
      sellerCommision: null,
      isReturnable: null,
      isStockable: null,
      isGoodsService: false,

      lens_Eye: "",
      lens_SPH: null,
      lens_CYL: null,
      lens_AXIS: null,
      lens_Dia: null,
      lens_Add: null,

      Attribute1: null,
      Attribute2: null,
      Attribute3: null,
      Attribute4: null,
      Attribute5: null,
      Note1: null,
      Note2: null,
      BatchNo: null,
      MgfDt: null,
      ExpDt: null,

      isAttributeItem: true,
      iAttributeParent: null,
      batchNos: [],
      itemOptionalFields: [],
    };

    const newItemList = {
      id1: 0,
      id2: 0,
      name: "",
      isDropdownOpen: false,
      highlightedIndex: -1,
      filteredProduct: [],
    };

    setItemMasterRows([...itemMasterRows, newItemRow]);
    setItemMasterList([...itemMasterList, newItemList]);
    setitemGroupMasterList([...itemMasterList, newItemList]);
    setSaleItemAddPage(false);
  };

  const handleDeleteRow = async (index, rowIndex) => {
    ;
    const updatedRows = itemMasterRows.filter((row, i) => i !== rowIndex);
    const updatedList = itemMasterList.filter((row, i) => i !== rowIndex);
    setItemMasterRows(updatedRows);
    setItemMasterList(updatedList);
    setSaleItemAddPage(false);
    if (index != 0) {
      var deleteProduct = await Transaction.RemoveProductTempData(
        ReferenceNumber,
        index
      );
      // ;
      if (deleteProduct == true) {
        GetProductDataFunction();
      }
    }
  };

  const [indexToEdit, setIndexToEdit] = useState();

  const handleEditRow = (index) => {
    setIndexToEdit(index);
    SaleItemAdd("edit");
  };

  //--------------- Row Input Calculation -----------------------

  const calculateTotalAmount = (Qty, itemPrice, DiscPer, DiscAmt, dicType_) => {
    // // ;
    let discount = 0;
    if (dicType_ === 1) {
      // Discount Percentage
      discount = itemPrice * (DiscPer / 100);
    } else if (dicType_ === 2) {
      // Discount Amount
      discount = DiscAmt;
    }
    const totalAmount = Qty * (itemPrice - discount);
    return { totalAmount, discount };
  };

  //--------------- Update the total quantity, price, and amount -----------------------
  const updateTotals = (rows) => {
    // let totalQty = 0;
    // let totalPrice = 0;
    // let totalDisc = 0;
    // let totalItemWiseTaxbleAmt = 0;
    // let totalAmount = 0;
    // let totalMrp = 0;
    // rows.forEach((row) => {
    //   totalQty += parseFloat(row.Qty) || 0;
    //   totalPrice += parseFloat(row.itemPrice) || 0;
    //   totalDisc += parseFloat(row.DiscAmt) || 0;
    //   totalItemWiseTaxbleAmt += parseFloat(row.itemWiseTaxbleAmt) || 0;
    //   totalAmount += parseFloat(row.TotalAmt) || 0;
    //   totalMrp += parseFloat(row.mrpPrice) || 0;
    // });
    // setInputValues((prevValues) => ({
    //   ...prevValues,
    //   TotalQty: totalQty.toFixed(2),
    //   TotalPrice: totalPrice.toFixed(2),
    //   TotalDisc: totalDisc.toFixed(2),
    //   TotalItemAmt: totalAmount.toFixed(2),
    //   TotalMrp: totalMrp.toFixed(2),
    //   TaxableAmt: totalItemWiseTaxbleAmt.toFixed(2),
    //   GrossAmt: totalAmount.toFixed(2),
    // }));
  };

  //---------------Row Input Change-----------------------
  const ensureNumeric = (value) => (isNaN(Number(value)) ? 0 : Number(value));

  const checkBarcodeType = (event, rowIndex, rowIndex1) => {
    const { name, value } = event.target;

    if (name == "defaultBarcode") {
      if (enableBarcodeGeneration == "0") {
        Swal.fire({
          title: "Invalid Barcode",
          text: "There is no product with this barcode.",
          icon: "warning",
          width: "350px",
          timer: 4000,
          showConfirmButton: false,
          timerProgressBar: true,
          customClass: {
            title: "swal2-custom-title",
            confirmButton: "my-confirm-button",
            cancelButton: "my-cancel-button",

            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        });
        setItemMasterRows((prevRows) => {
          const newRows = [...prevRows];
          newRows[rowIndex] = {
            ...newRows[rowIndex],
            [name]: "",
          };
          updateTotals(newRows);
          return newRows;
        });
      } else if (enableBarcodeGeneration == "1") {
        Swal.fire({
          title: "Invalid Barcode",
          text: "There is no product with this barcode.",
          icon: "warning",
          width: "350px",
          timer: 4000,
          showConfirmButton: false,
          timerProgressBar: true,
          customClass: {
            title: "swal2-custom-title",
            confirmButton: "my-confirm-button",
            cancelButton: "my-cancel-button",

            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        });
        setItemMasterRows((prevRows) => {
          const newRows = [...prevRows];
          newRows[rowIndex] = {
            ...newRows[rowIndex],
            [name]: "",
          };
          updateTotals(newRows);
          return newRows;
        });
      } else if (enableBarcodeGeneration == "2") {
        Swal.fire({
          title: "There is no product with this barcode.",
          text: "Do you want to create a new barcode?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          width: "350px",
          customClass: {
            title: "swal2-custom-title",
            confirmButton: "my-confirm-button",
            cancelButton: "my-cancel-button",

            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            console.log("User chose to create a new barcode.");
          } else {
            setItemMasterRows((prevRows) => {
              const newRows = [...prevRows];
              newRows[rowIndex] = {
                ...newRows[rowIndex],
                [name]: "",
              };
              updateTotals(newRows);
              return newRows;
            });
            console.log("User chose not to create a new barcode.");
            return;
          }
        });
      }
    }
  };

  const handleInputChange = async (event, rowIndex, rowIndex1) => {
    const { name, value } = event.target;
    ;

    if (
      (name == "Qty" ||
        name == "FreeQty" ||
        name == "itemPrice" ||
        name == "DiscPer" ||
        name == "DoubleDis" ||
        name == "DiscAmt" ||
        name == "TotalAmt" ||
        name == "mrpPrice" ||
        name == "saleProfit" ||
        name == "purPageSalePrice") &&
      value != ""
    ) {
      // const isValidNumber = /^-?\d*(\.\d+)?$/.test(value.trim());
      const isValidNumber = /^-?\d*(\.\d*)?$/.test(value.trim());
      if (!isValidNumber) {
        return;
      }
    }
    // ;
    if (name === "DiscPer") {
      const numericValue = Number(value);

      if (isNaN(numericValue) || numericValue < 0) {
        alert("Discount Percentage should be a positive number.");
        return;
      }

      if (numericValue > 100) {
        alert("Discount Percentage cannot exceed 100%.");
        return;
      }
    }

    if (name === "DiscAmt") {
      // ;
      var getRow = itemMasterRows.filter((item) => item.rowIndex == rowIndex1);
      const { Qty, itemPrice } = getRow[0];

      var DiscPerValue = (value * 100) / (Qty * itemPrice);
      var Totalamt = Qty * itemPrice - (DiscPerValue * (Qty * itemPrice)) / 100;
      setChangeInData(true);
      setItemMasterRows((prevRows) => {
        const newRows = [...prevRows];
        newRows[rowIndex] = {
          ...newRows[rowIndex],
          [name]: value !== 0 ? value : "",
          DiscPer: DiscPerValue !== 0 ? DiscPerValue.toFixed(4) : "",
          TotalAmt: Totalamt !== 0 ? Totalamt.toFixed(4) : "",
        };

        updateTotals(newRows);
        return newRows;
      });
      return;
    }

    if (name === "DiscPer") {
      var getRow = itemMasterRows.filter((item) => item.rowIndex == rowIndex1);
      const { Qty, itemPrice } = getRow[0];

      var DiscPerValue = (value * (Qty * itemPrice)) / 100;
      var Totalamt = Qty * itemPrice - DiscPerValue;
      setChangeInData(true);
      setItemMasterRows((prevRows) => {
        const newRows = [...prevRows];
        newRows[rowIndex] = {
          ...newRows[rowIndex],
          [name]: value !== 0 ? value : "",
          DiscAmt: DiscPerValue !== 0 ? DiscPerValue.toFixed(4) : "",
          TotalAmt: Totalamt !== 0 ? Totalamt.toFixed(4) : "",
        };

        updateTotals(newRows);
        return newRows;
      });
    }

    if (name === "Qty") {
      var getRow = itemMasterRows.filter((item) => item.rowIndex == rowIndex1);
      const { DiscPer, itemPrice } = getRow[0];

      var DiscPerValue = (DiscPer * (value * itemPrice)) / 100;
      var Totalamt = value * itemPrice - DiscPerValue;
      setChangeInData(true);
      setItemMasterRows((prevRows) => {
        const newRows = [...prevRows];
        newRows[rowIndex] = {
          ...newRows[rowIndex],
          [name]: value !== 0 ? value : "",
          DiscAmt: DiscPerValue !== 0 ? DiscPerValue.toFixed(4) : "",
          TotalAmt: Totalamt !== 0 ? Totalamt.toFixed(4) : "",
        };

        updateTotals(newRows);
        return newRows;
      });
    }

    if (name === "itemPrice") {
      var getRow = itemMasterRows.filter((item) => item.rowIndex == rowIndex1);
      const { DiscPer, Qty } = getRow[0];

      var DiscPerValue = (DiscPer * (Qty * value)) / 100;
      var Totalamt = Qty * value - DiscPerValue;
      setChangeInData(true);
      setItemMasterRows((prevRows) => {
        const newRows = [...prevRows];
        newRows[rowIndex] = {
          ...newRows[rowIndex],
          [name]: value !== 0 ? value : "",
          DiscAmt: DiscPerValue !== 0 ? DiscPerValue.toFixed(4) : "",
          TotalAmt: Totalamt !== 0 ? Totalamt.toFixed(4) : "",
        };

        updateTotals(newRows);
        return newRows;
      });
    }

    if (enableBatchNoEntry == "2") {
      if (name == "Qty") {
        handleBatchdataChange(rowIndex, "qty", value);
      } else if (name == "itemPrice") {
        handleBatchdataChange(rowIndex, "salePrice", value);
      } else if (name == "mrpPrice") {
        handleBatchdataChange(rowIndex, "mrp", value);
      } else if (name == "mrpPrice") {
        handleBatchdataChange(rowIndex, "purPrice", value);
      }
    }

    let isValid = true;
    const checkValue = value;
    if (checkValue === undefined) {
      return;
    }
    // 
    if (isValid) {
      setChangeInData(true);
      setItemMasterRows((prevRows) => {
        const newRows = [...prevRows];
        newRows[rowIndex] = {
          ...newRows[rowIndex],
          [name]: value,
        };

        updateTotals(newRows);

        return newRows;
      });
      setHighlightedIndex7(-1);
      setHighlightedIndex8(-1);
      setHighlightedIndex9(-1);
      setHighlightedIndex10(-1);
      setHighlightedIndex11(-1);
    }
  };

  const handleBatchdataChange = (index, field, value) => {
    // ;
    if (field == "qty") {
      if (Number(value) < 0) {
        alert("Quantity cannot be negative");
        return;
      }
      if (enableBatchNoEntry == "1") {
        if (Number(value) > Number(BatchNoData[index].AvaliableQty)) {
          alert("Quantity cannot be greater than available quantity");
          return;
        }
      }
      if (Number(value) > Number(ProductOpnedInPopup?.Qty)) {
        alert("Quantity cannot be greater than Buying Quantity");
        return;
      }
    }

    setBatchNoData((prevData) =>
      prevData.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  };

  useEffect(() => {
    // ;
    if (enableBatchNoEntry == "1") {
      if (BatchNoData) {
        if (setItemMasterRows) {
          var FilteredBatchNoData = BatchNoData?.filter(
            (item) =>
              item.batchNo.trim() !== "" && item.qty !== "" && item.qty != 0
          );
          console.log(FilteredBatchNoData);
          setItemMasterRows((prevRows) => {
            return prevRows.map((row, idx) => {
              if (FilteredBatchNoData) {
                return { ...row, batchNos: FilteredBatchNoData };
              }
              return row;
            });
          });
        } else {
          var FilteredBatchNoData = BatchNoData;
          setInputValues((prev) => ({
            ...prev,
            BatchDetails: FilteredBatchNoData,
          }));
        }
      }
    } else if (enableBatchNoEntry == "2") {
      if (BatchNoData) {
        if (setItemMasterRows) {
          var FilteredBatchNoData = BatchNoData?.filter(
            (item) => item.batchNo.trim() !== ""
          );
          console.log(FilteredBatchNoData);
          setItemMasterRows((prevRows) => {
            return prevRows.map((row, idx) => {
              if (FilteredBatchNoData) {
                return { ...row, batchNos: FilteredBatchNoData };
              }
              return row;
            });
          });
        } else {
          var FilteredBatchNoData = BatchNoData;
          setInputValues((prev) => ({
            ...prev,
            BatchDetails: FilteredBatchNoData,
          }));
        }
      }
    }
  }, [BatchNoData]);

  const [units, setUnits] = useState([
    {
      id: 0,
      name: "",
      isDropdownOpen: false,
      highlightedIndex: -1,
      filteredProduct: [],
    },
  ]);

  const handleKeyDown_UnitSuggestion = (e, rowIndex) => {
    // Validate `rowIndex`

    setTimeout(() => {
      // if (rowIndex < 0 || rowIndex > units.length) {
      //   console.error("Invalid rowIndex:", rowIndex);
      //   return;
      // }
      if (rowIndex < 0) {
        console.error("Invalid rowIndex:", rowIndex);
        return;
      }

      // Safely access the row
      const row = itemMasterRows[rowIndex];
      if (!row) {
        console.error("Undefined row at index:", rowIndex);
        return;
      }

      const { filteredProduct = [], highlightedIndex = 0 } = row;

      // Handle empty product list
      if (!filteredProduct.length) {
        handleProductRowKeyDown(e, rowIndex, 5);
        // return;
      }

      switch (e.key) {
        case "ArrowDown":
          if (!units[rowIndex] || !units[rowIndex].isDropdownOpen) {
            return;
          }
          e.preventDefault();
          setUnits((prevRows) => {
            const newRows = [...prevRows];
            const currentHighlightedIndex =
              newRows[rowIndex]?.highlightedIndex || 0;
            const totalItems = newRows[rowIndex].filteredProduct.length || 0;
            newRows[rowIndex].highlightedIndex =
              (currentHighlightedIndex + 1) % totalItems;
            return newRows;
          });
          // setHighlightedIndex((prevIndex) => prevIndex + 1);

          setHighlightedIndex((prevIndex) => {
            const totalItems = units[rowIndex]?.filteredProduct.length || 0;
            let newIndex = prevIndex + 1;

            // Reset to -1 if newIndex exceeds the totalItems
            if (newIndex >= totalItems) {
              newIndex = 0;
            }

            return newIndex;
          });

          break;

        case "ArrowUp":
          if (!units[rowIndex] || !units[rowIndex].isDropdownOpen) {
            return;
          }
          e.preventDefault();
          setUnits((prevRows) => {
            const newRows = [...prevRows];
            const currentHighlightedIndex =
              newRows[rowIndex]?.highlightedIndex || 0;
            const totalItems = newRows[rowIndex].filteredProduct.length || 0;
            // newRows[rowIndex].highlightedIndex =
            //   currentHighlightedIndex === 0
            //     ? filteredProduct.length - 1
            //     : currentHighlightedIndex - 1;
            if (totalItems > 0) {
              newRows[rowIndex].highlightedIndex =
                (currentHighlightedIndex - 1 + totalItems) % totalItems;
            }
            return newRows;
          });
          // setHighlightedIndex((prevIndex) =>
          //   prevIndex === 0 ? filteredProduct.length - 1 : prevIndex - 1
          // );

          setHighlightedIndex((prevIndex) => {
            const totalItems = units[rowIndex]?.filteredProduct.length || 0;
            let newIndex = prevIndex - 1;

            // If newIndex is less than 0, reset to the last item
            if (newIndex < 0) {
              newIndex = totalItems - 1; // Reset to the last item when the index goes below 0
            }

            return newIndex;
          });

          break;

        case "Enter":
          e.preventDefault();
          if (e.target.name != "productUnitName") {
            // highlightedIndex >= 0 && highlightedIndex < filteredProduct.length;
          } else {
            // ;
            if (
              highlightedIndex >= 0 &&
              highlightedIndex < units[rowIndex]?.filteredProduct.length
            ) {
              handleUnitSelection(
                rowIndex,
                units[rowIndex].filteredProduct[
                  units[rowIndex].highlightedIndex
                ]
              );
            }
          }
          break;

        case "Escape":
          setItemMasterList((prevRows) => {
            const newRows = [...prevRows];
            newRows[rowIndex].isDropdownOpen = false;
            return newRows;
          });
          break;

        default:
          break;
      }
    }, 100);
  };

  const OpenSuggestionUnit = async (event, rowIndex) => {
    const { name, value } = event.target;
    getPosition(rowIndex, 5);
    // await handleInputChange(event, rowIndex);
    // // ;
    const filteredData = {
      MasterType: 8,
      GroupWiseSuggestion: false,
      GroupId: [],
      search_str: value,
      PageNumber: 1,
      PageSize: 50,
    };
    try {
      const Unit = await Account.GetAccountListForAutoSuggestion(filteredData);

      if (Unit && Unit.length > 0) {
        setUnits((prevRows) => {
          const newRows = [...prevRows];
          newRows[rowIndex] = {
            ...newRows[rowIndex],
            name: value,
            filteredProduct: Unit || [],
            isDropdownOpen: true,
            highlightedIndex: -1,
          };
          return newRows;
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  const debouncedOpenSuggestionUnit = useCallback(
    debounce(OpenSuggestionUnit, 500), // Set the debounce delay (e.g., 500ms)
    []
  );
  const handleUnitSelection = async (rowIndex, selectedItem) => {
    // ;
    setItemMasterRows((prevRows) => {
      const newRows = [...prevRows];

      newRows[rowIndex] = {
        ...newRows[rowIndex],
        productUnitName: selectedItem?.name,
        productUnit: selectedItem?.id,
      };
      return newRows;
    });
    // setGroupSuggestionShow(false);

    setUnits((prevRows) => {
      const newRows = [...prevRows];
      newRows[rowIndex].isDropdownOpen = false;
      newRows[rowIndex].filteredProduct = [];
      return newRows;
    });
  };

  useEffect(() => {
    console.log("units", units);
  }, [units]);

  // TotalAmount Calculation

  //---------------Adding items from the Popup-----------------------

  // const AddingItrmFromPopUp = (event) => {
  //   var rowIndex = itemMasterList.length - 1;
  //   // // ;
  //   console.log(event.target.value, event.target.name, rowIndex);

  //   const { name, value } = event.target;

  //   setItemMasterRows((prevRows) => {
  //     const newRows = [...prevRows];
  //     newRows[rowIndex] = {
  //       ...newRows[rowIndex],
  //       [name]: value,
  //     };

  //     // TotalAmount Calculation
  //     const { Qty, itemPrice, DiscPer, DiscAmt } = newRows[rowIndex];
  //     if (
  //       name === "Qty" ||
  //       name === "itemPrice" ||
  //       name === "DiscPer" ||
  //       name === "DiscAmt"
  //     ) {
  //       let dicType_ = 0;
  //       if (name === "DiscPer") {
  //         dicType_ = 1;
  //       }
  //       if (name === "DiscAmt") {
  //         dicType_ = 2;
  //       }
  //       const { totalAmount, discount } = calculateTotalAmount(
  //         Qty,
  //         itemPrice,
  //         DiscPer,
  //         DiscAmt,
  //         dicType_
  //       );
  //       newRows[rowIndex].TotalAmt = totalAmount.toFixed(2);
  //       newRows[rowIndex].amt_after_discount = totalAmount.toFixed(2);
  //       if (name !== "DiscAmt") {
  //         newRows[rowIndex].DiscAmt = discount.toFixed(2);
  //       }
  //     }
  //     //handleGSTCalculation(newRows[rowIndex]);

  //     (async () => {
  //       try {
  //         const gstCalculationResult =
  //           await Gst_Calculation.ItemWiseGSTCalculation(
  //             newRows[rowIndex],
  //             itemMasterRows,
  //             setItemMasterRows,
  //             BillTypeSetting,
  //             inputValues,
  //             sundryRows
  //           );
  //         // // ;
  //         // Destructure the result only if the function returns an object
  //         if (gstCalculationResult) {
  //           const { taxable_item_price, tAmt1, tAmt2, tAmt3, tAmt4, value1 } =
  //             gstCalculationResult;
  //           // // ;
  //           // Update the current row with GST calculations
  //           newRows[rowIndex] = {
  //             ...newRows[rowIndex],
  //             itemWiseTaxbleAmt: ensureNumeric(taxable_item_price),
  //             taxAmt_Cgst: ensureNumeric(tAmt1),
  //             taxAmt_Sgst: ensureNumeric(tAmt2),
  //             taxAmt_Igst: ensureNumeric(tAmt3),
  //             taxAmt_Cess: ensureNumeric(tAmt4),
  //             TotalAmt: ensureNumeric(value1),
  //           };
  //         }
  //         setItemMasterRows(newRows);
  //       } catch (err) {
  //         console.error("Error in GST Calculation:", err);
  //       }
  //     })();

  //     // Update the total values
  //     updateTotals(newRows);

  //     return newRows;
  //   });
  // };

  //---------------Product Name Change-----------------------

  const handleProductNameChange = async (
    event,
    rowIndex,
    ShowMainProductOnlyInItemSuggestion1
  ) => {
    const { value } = event.target;

    getPosition(rowIndex, 3);

    // handleInputChange(event, rowIndex);

    try {
      // const filteredData = {
      //   search_str: value,
      //   PageNumber: 1,
      //   PageSize: 50,
      // };
      // const SearchItem = await ItemMasterAPI.GetItemList(filteredData); // Assuming GetItemList returns a

      console.log(
        "ShowMainProductOnlyInItemSuggestion",
        ShowMainProductOnlyInItemSuggestion1
      );
      ;
      const filteredData = {
        MasterType: 4,
        IsAttributeParent: ShowMainProductOnlyInItemSuggestion1 || false,
        GroupWiseSuggestion: false,
        GroupId: "",
        search_str: value,
        PageNumber: 1,
        PageSize: 50,
        IsEcomStore: false,
      };
      const SearchItem = await Account.GetAccountListForAutoSuggestion(
        filteredData
      );

      setItemMasterList((prevRows) => {
        const newRows = [...prevRows];
        newRows[rowIndex] = {
          ...newRows[rowIndex],
          name: value,
          filteredProduct: SearchItem || [],
          isDropdownOpen: true,
          highlightedIndex: -1,
        };
        return newRows;
      });
      // // ;
      console.log("changed");

      // if (ShowMainProductOnlyInItemSuggestion?.enableDisable == true) {
      //   var FilteredSearchItem = SearchItem.filter(
      //     (item) => item.attributeParentId2 == 0
      //   );

      // } else {
      //   setItemMasterList((prevRows) => {
      //     const newRows = [...prevRows];
      //     newRows[rowIndex] = {
      //       ...newRows[rowIndex],
      //       name: value,
      //       filteredProduct: SearchItem || [],
      //       isDropdownOpen: true,
      //       highlightedIndex: -1,
      //     };
      //     return newRows;
      //   });
      //   // }
      // }
    } catch (error) {
      console.error("Error fetching item list:", error);
    }
  };

  const debouncedHandleProductNameChange = useCallback(
    debounce(handleProductNameChange, 200), // Set the debounce delay (e.g., 500ms)
    []
  );
  //---------------Product Name Change-----------------------
  // const [GroupSuggestionShow, setGroupSuggestionShow] = useState(false);
  // const [ItemGroupList, setItemGroupList] = useState([]);

  const OpenSuggestionItemGroup = async (event, rowIndex) => {
    // // ;
    const { name, value } = event.target;
    getPosition(rowIndex, 2);

    // handleInputChange(event, rowIndex);
    // // ;
    if (value && value.trim() != "") {
      const filteredData = {
        MasterType: 3,
        GroupWiseSuggestion: false,
        GroupId: [],
        search_str: value,
        PageNumber: 1,
        PageSize: 50,
      };

      var data = await Account.GetAccountListForAutoSuggestion(filteredData);
      if (data) {
        // setItemGroupList(data);
        setitemGroupMasterList((prevRows) => {
          const newRows = [...prevRows];
          newRows[rowIndex] = {
            ...newRows[rowIndex],
            name: value,
            filteredProduct: data || [],
            isDropdownOpen: true,
            highlightedIndex: -1,
          };
          return newRows;
        });
      }
    }
  };
  const debouncedOpenSuggestionItemGroup = useCallback(
    debounce(OpenSuggestionItemGroup, 500), // Set the debounce delay (e.g., 500ms)
    []
  );
  const handleProductGroupSelection = async (rowIndex, selectedItem) => {
    // // ;
    setItemMasterRows((prevRows) => {
      const newRows = [...prevRows];

      newRows[rowIndex] = {
        ...newRows[rowIndex],
        parentGrp: selectedItem?.id,
        parentGrpName: selectedItem?.name,
      };
      return newRows;
    });

    setitemGroupMasterList((prevRows) => {
      const newRows = [...prevRows];
      newRows[rowIndex].isDropdownOpen = false;
      newRows[rowIndex].filteredProduct = [];
      return newRows;
    });

    setHighlightedIndex(-1);
  };

  const [ProductRangeDataMain, setProductRangeDataMain] = useState({});
  const fetchDataForSerialNo = async (e, rowIndex1, rowIndex) => {
    // ;
    var D2Id = itemMasterRows[rowIndex]?.d2_Id || 0;

    if (D2Id === "" || D2Id === undefined) {
      return;
    } else {
      if (e.target.value && e.target.value != "") {
        handleProductSelection(
          rowIndex,
          {},
          e,
          rowIndex1,
          true,
          e.target.value
        );
      }
    }
  };

  const handleProductSelection = async (
    rowIndex,
    selectedItem,
    e,
    rowIndex1,
    IsBarcode = false,
    Barcode
  ) => {
    // setLoading(true);
    ;
    if (Barcode) {
      var filterData = {
        searchTypeId: 1,
        code: Barcode,
      };
      const ItemData = await Transaction.GetBarcodeSerialBatchNoForItemFetch(
        filterData
      );
      ;
      if (ItemData && Object.keys(ItemData).length > 0) {
        setItemWhenProductselected(
          e,
          ItemData,
          rowIndex,
          rowIndex1,
          Barcode,
          IsBarcode,
          selectedItem
        );
      } else {
        await checkBarcodeType(e, rowIndex, rowIndex1);
      }
    } else {
      if (!selectedItem) {
        return;
      }
      var ItemMasterId =
        selectedItem.id2 || selectedItem.itmId_d2 || selectedItem.id;
      // const ItemData = await ItemMasterAPI.GetItemMasterById(ItemMasterId);
      var filterData = {
        searchTypeId: 4,
        itmId_d2: ItemMasterId,
      };
      const ItemData = await Transaction.GetBarcodeSerialBatchNoForItemFetch(
        filterData
      );
      if (ItemData && Object.keys(ItemData).length > 0) {
        setItemWhenProductselected(
          e,
          ItemData,
          rowIndex,
          rowIndex1,
          Barcode,
          IsBarcode,
          selectedItem
        );
      }
    }

    // setLoading(false);
  };

  const setItemWhenProductselected = async (
    e,
    ItemData,
    rowIndex,
    rowIndex1,
    Barcode,
    IsBarcode,
    selectedItem
  ) => {
    ;
    var CodeNew = GenerateCode();

    if (allSettings) {
      const NegativeStockAlert = allSettings.find(
        (s) => s.masterSettName === "NegativeStockAlert"
      );
      const NegativeStockBillingRestriction = allSettings.find(
        (s) => s.masterSettName === "NegativeStockBillingRestriction"
      );
      if ((NegativeStockAlert && NegativeStockAlert?.enableDisable) || false) {
        var stock = await fetchItemStock(ItemData.d1_Id, ItemData.d2_Id);
        if (stock <= 0) {
          Swal.fire({
            title: "Out Of Stock",
            text: "There is no stock available for this product.",
            icon: "warning",
            width: "250px",
            timer: 4000,
            showConfirmButton: false,
            timerProgressBar: true,
            customClass: {
              title: "swal2-custom-title",
              confirmButton: "my-confirm-button",
              cancelButton: "my-cancel-button",
              popup: "swal2-custom-popup",
              htmlContainer: "swal2-custom-text",
              icon: "swal2-custom-icon",
            },
          });
          if (
            (NegativeStockBillingRestriction &&
              NegativeStockBillingRestriction?.enableDisable) ||
            false
          ) {
            setLoading(false);
            return;
          }
        }
      }
    }

    let newrows = [];
    if (ItemData) {
      setItemMasterList((prevRows) => {
        const newRows = [...prevRows];
        if (newRows[rowIndex]) {
          newRows[rowIndex].isDropdownOpen = false;
          newRows[rowIndex].filteredProduct = [];
          newRows[rowIndex].highlightedIndex = -1;
        }
        return newRows;
      });

      let itemPriceNew;

      if (IsBarcode) {
        if (selectedItem.sellingPrice) {
          itemPriceNew = selectedItem.sellingPrice;
        } else if (Number(TransAccountId) === 216) {
          itemPriceNew = ItemData.salePrice;
        } else if (Number(TransAccountId) === 215) {
          itemPriceNew = ItemData.purchasePrice;
        } else {
          itemPriceNew = ItemData.salePrice;
        }
      } else {
        if (Number(TransAccountId) === 216) {
          itemPriceNew = ItemData.salePrice;
        } else if (Number(TransAccountId) === 215) {
          itemPriceNew = ItemData.purchasePrice;
        } else {
          itemPriceNew = ItemData.salePrice;
        }
      }
      setItemMasterRows((prevRows) => {
        const existingRow = prevRows[rowIndex];

        if (IsBarcode) {
          if (
            existingRow?.d1_Id === ItemData.d1_Id ||
            existingRow?.d2_Id === ItemData.d2_Id
          ) {
            setApiCallProductAllowed(true); // Disable further API calls
            return prevRows;
          }
        }

        const newRows = [...prevRows];
        newRows[rowIndex] = {
          ...existingRow,
          d1_Id: ItemData.d1_Id || "",
          d2_Id: ItemData.d2_Id || "",
          productName: ItemData.productName || "",
          parentGrp: ItemData.parentGrp2 || "",
          parentGrpName: ItemData.parentGrpName || "",
          productUnitName: ItemData.productUnitName || "",
          productUnit: ItemData.productUnit || "",
          productAltUnit: ItemData.productAltUnit || "",
          unitConvFactor: ItemData.unitConvFactor || "",
          enableBarcode: ItemData.enableBarcode || "",
          defaultBarcode: Barcode || ItemData.Barcode || "",
          batchNos: ItemData.batchDetails || [],
          taxCategory1: ItemData.taxCategory1 || "",
          taxLimit: ItemData.taxLimit || "",
          taxCategory2: ItemData.taxCategory2 || "",
          hsnCode: ItemData.hsnCode || "",
          shortDescription: "",
          Qty: ItemData.Qty === 0 ? 1 : ItemData.Qty || 1,
          FreeQty: ItemData.FreeQty || "",
          purchasePrice: ItemData.purchasePrice || "",
          purchaseDiscount: ItemData.purchaseDiscount || "",
          saleProfit: ItemData.saleProfit || "",
          salePrice: ItemData.salePrice || "",
          saleDiscount: ItemData.saleDiscount || "",
          itemPrice: itemPriceNew || 0,
          costPrice: ItemData.costPrice || "",
          mrpPrice: ItemData.mrpPrice || "",
          DiscPer:
            Number(TransAccountId) === 216
              ? ItemData.saleDiscount
              : Number(TransAccountId) === 215
              ? ItemData.purchaseDiscount
              : ItemData.saleDiscount,
          DiscAmt: ItemData.DiscAmt || "",
          TotalAmt: ItemData.TotalAmt || "",
          purPageSalePrice: ItemData.salePrice || "",
          availableQuantity: ItemData.availableQuantity || "",
          lens_Eye: (ItemData?.lens_Eye || "").split(",")[0] || "",
          lens_SPH:
            ItemData.lens_Eye != null
              ? ItemData.lens_SPH
                ? parseFloat(ItemData.lens_SPH).toFixed(2)
                : ""
              : "",
          lens_CYL:
            ItemData.lens_Eye != null
              ? ItemData.lens_CYL
                ? parseFloat(ItemData.lens_CYL).toFixed(2)
                : ""
              : "",

          lens_AXIS:
            ItemData.lens_AXIS && ItemData.lens_AXIS !== 0
              ? ItemData.lens_AXIS
              : "",
          lens_Dia:
            ItemData.lens_Dia && ItemData.lens_Dia !== 0
              ? ItemData.lens_Dia
              : "",
          lens_Add:
            ItemData.lens_Add && ItemData.lens_Add !== 0
              ? ItemData.lens_Add.toFixed(2)
              : "",
          enableSerialNo: ItemData.enableSerialNo || "",
          taxCat1_Cgst: ItemData.taxCat1_Cgst || "",
          taxCat1_Sgst: ItemData.taxCat1_Sgst || "",
          taxCat1_Igst: ItemData.taxCat1_Igst || "",
          taxCat1_Cess: ItemData.taxCat1_Cess || "",
          taxCategory2: ItemData.taxCategory2 || "",
          taxCat2_Cgst: ItemData.taxCat2_Cgst || "",
          taxCat2_Sgst: ItemData.taxCat2_Sgst || "",
          taxCat2_Igst: ItemData.taxCat2_Igst || "",
          taxCat2_Cess: ItemData.taxCat2_Cess || "",
          masterDescription: CodeNew,
          LensTypeEf: ItemData.LensTypeEf || "",
        };

        newrows = newRows;
        return newRows;
      });

      // if (ItemData?.batchDetails?.length > 0) {
      //   setBatchNoData(ItemData.batchDetails);
      // }
      setHighlightedIndex(-1);

      // if (ItemData.taxCategory1 && ItemData.taxCategory1 != 0) {
      //   fetchBillTypeSett(ItemData.taxCategory1, rowIndex);
      // }
    }
    ;
    // if (ProductRangeDataMain) {
    // const PowerRangeData = await LensItemCreation.getLensItemCreationByItemId(
    //   selectedItem.id2 || selectedItem.itmId_d2
    // );

    const PowerRangeData = {
      add_min: ItemData.add_min || "",
      add_max: ItemData.add_max || "",
      add_step: ItemData.add_step || "",
      cyl_min: ItemData.cyl_min || "",
      cyl_max: ItemData.cyl_max || "",
      cyl_step: ItemData.cyl_step || "",
      sph_min: ItemData.sph_min || "",
      sph_max: ItemData.sph_max || "",
      sph_step: ItemData.sph_step || "",
      Eye: ItemData.Eye || "",
    };

    setProductRangeDataMain(PowerRangeData);
    // ;
    if (PowerRangeData.cyl_max != "" && PowerRangeData.sph_max != "") {
      if (PowerRangeData) {
        // Generate values for each list based on PowerRangeData
        const values1 = [];
        for (
          let i = parseFloat(PowerRangeData.add_min);
          i <= parseFloat(PowerRangeData.add_max);
          i += parseFloat(PowerRangeData.add_step)
        ) {
          values1.push(i);
        }

        const values2 = [];
        for (
          let i = parseFloat(PowerRangeData.cyl_min);
          i <= parseFloat(PowerRangeData.cyl_max);
          i += parseFloat(PowerRangeData.cyl_step)
        ) {
          values2.push(i);
        }

        const values3 = [];
        for (
          let i = parseFloat(PowerRangeData.sph_min);
          i <= parseFloat(PowerRangeData.sph_max);
          i += parseFloat(PowerRangeData.sph_step)
        ) {
          values3.push(i);
        }

        const axis = ItemData.axis;
        const axisValues = axis.split(",").map(Number); // Convert "45,90,180" into an array of numbers [45, 90, 180]

        const values4 = [];

        // Loop through each value in axisValues
        for (let value of axisValues) {
          values4.push(value); // You can perform other operations with 'value' inside the loop if needed
        }

        const EYE = PowerRangeData.Eye || "R,L,RL";
        const EyeValues = EYE.split(","); // Split the string into an array of ["R", "L", "RL"]
        // Create the values5 array directly by using map
        const values5 = EyeValues.map((eye) => {
          // Optional: You could add transformations here if needed
          return eye; // Since you seem to want to keep the values the same, just return the value
        });

        console.log(values5); // Output: ["R", "L", "RL"]

        // Update the specific row in the state arrays
        setPowerRangeADD((prevState) => {
          if (values1.length > 0) {
            const updatedState = [...prevState];
            updatedState[rowIndex] = {
              PowerRangeADDShow: false,
              PowerRangeADDList: values1,
            };
            return updatedState;
          }
          return prevState;
        });

        setPowerRangeCYL((prevState) => {
          if (values2.length > 0) {
            const updatedState = [...prevState];
            updatedState[rowIndex] = {
              PowerRangeCYLShow: false,
              PowerRangeCYLList: values2,
            };
            return updatedState;
          }
          return prevState;
        });

        setPowerRangeSPH((prevState) => {
          if (values3.length > 0) {
            const updatedState = [...prevState];
            updatedState[rowIndex] = {
              PowerRangeSPHShow: false,
              PowerRangeSPHList: values3,
            };
            return updatedState;
          }
          return prevState;
        });

        setPowerRangeAXIS((prevState) => {
          if (values4.length > 0) {
            const updatedState = [...prevState];
            updatedState[rowIndex] = {
              PowerRangeAXISShow: false,
              PowerRangeAXISList: values4,
            };
            return updatedState;
          }
          return prevState;
        });

        setPowerRangeEYE((prevState) => {
          if (values5.length > 0) {
            const updatedState = [...prevState];
            updatedState[rowIndex] = {
              PowerRangeEYEShow: false,
              PowerRangeEYEList: values5,
            };
            return updatedState;
          }
          return prevState;
        });
      }
    }

    // }
    // setLoading(false);

    setTimeout(async () => {
      await onChangeProductSaveMethod(
        e,
        rowIndex1,
        rowIndex,
        "",
        newrows,
        true
      );
    }, 10);
  };

  const handleDebouncedSelection = debounce(handleProductSelection, 500);

  let preventBlur = false;

  //---------------Get TaxCategory By Id (on item select)-----------------------

  const fetchBillTypeSett = async (itaxCategoryId, rowIndex) => {
    try {
      const TaxData = await TaxCategoryApi.getTaxCategoryById(itaxCategoryId);
      console.log(TaxData);
      if (TaxData) {
        setItemMasterRows((prevRows) => {
          const newRows = Array.isArray(prevRows) ? [...prevRows] : [];
          newRows[rowIndex] = {
            ...newRows[rowIndex],
            taxCat1_Cgst: TaxData.localTaxCGST,
            taxCat1_Sgst: TaxData.localTaxSGST,
            taxCat1_Igst: TaxData.centralTaxIGST,
            taxCat1_Cess: TaxData.cessTax,
          };
          return newRows;
        });
      } /**/ else {
        setItemMasterRows((prevRows) => {
          const newRows = Array.isArray(prevRows) ? [...prevRows] : [];

          newRows[rowIndex] = {
            ...newRows[rowIndex],
            taxCat1_Cgst: 0,
            taxCat1_Sgst: 0,
            taxCat1_Igst: 0,
            taxCat1_Cess: 0,
          };
          return newRows;
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [highlightedIndex7, setHighlightedIndex7] = useState(-1);
  const [highlightedIndex8, setHighlightedIndex8] = useState(-1);
  const [highlightedIndex9, setHighlightedIndex9] = useState(-1);
  const [highlightedIndex10, setHighlightedIndex10] = useState(-1);
  const [highlightedIndex11, setHighlightedIndex11] = useState(-1);

  useEffect(() => {
    const blockedKeys = [33, 34, 38, 40]; // Array of keys to block (PageUp, PageDown, ArrowUp, ArrowDown)

    const handleKeyDown = (e) => {
      const key = e.which || e.keyCode;
      if (blockedKeys.includes(key)) {
        e.preventDefault();
        return false;
      }
      return true;
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleProductRowKeyDown = async (event, rowIndex, columnIndex) => {
    // // ;
    if (event.key === "Enter" || event.key === "PageDown") {
      event.preventDefault();
      event.stopPropagation();
      const { name, value } = event.target;
      // Add a new row if at the end and 'Enter' is pressed
      if (rowIndex === itemMasterRows.length - 1) {
        if (
          name === "TotalAmt" ||
          name === "salePriceForPur" ||
          name === "saleProfit" ||
          name === "mrpPrice" ||
          name === "BrkgAmt"
        ) {
          await handleAddRow();
        }
      }

      // Calculate next column index
      const nextColumnIndex = columnIndex + 1;
      let nextRowCellRef =
        nextCellRefsProduct.current[rowIndex][nextColumnIndex];

      if (!nextRowCellRef) {
        for (let i = nextColumnIndex; i < 35; i++) {
          const cellRef = nextCellRefsProduct.current[rowIndex][i]; // Assuming index 0 for the first column
          if (cellRef) {
            nextRowCellRef = cellRef;
            break;
          }
        }
      }

      if (nextRowCellRef) {
        nextRowCellRef.focus();
        nextRowCellRef.select();
      } else {
        setTimeout(() => {
          const nextRowIndex = rowIndex + 1;
          let nextRowCellId = `Code-td-${nextRowIndex}`;
          let nextRowCell = document.getElementById(nextRowCellId);
          if (!nextRowCell) {
            nextRowCellId = `Group-td-${nextRowIndex}`;
            nextRowCell = document.getElementById(nextRowCellId);
          }

          if (!nextRowCell) {
            nextRowCellId = `ItemName-td-${nextRowIndex}`;
            nextRowCell = document.getElementById(nextRowCellId);
          }

          if (nextRowCell) {
            nextRowCell.focus();
          }
        }, 10);
      }
    } else if (event.key === "PageUp") {
      // ;
      event.preventDefault();
      event.stopPropagation();
      // ;

      const { name, value } = event.target;
      const nextColumnIndex = columnIndex - 1;
      let nextRowCellRef =
        nextCellRefsProduct.current[rowIndex][nextColumnIndex];

      if (!nextRowCellRef) {
        for (let i = nextColumnIndex; i > 0; i--) {
          // ;
          // Loop from nextColumnIndex down to 0
          const cellRef = nextCellRefsProduct.current[rowIndex][i]; // Assuming index 0 for the first column
          if (cellRef) {
            nextRowCellRef = cellRef;
            break;
          }
        }
      }

      if (name == "defaultBarcode" && inputRefs.current[37]) {
        inputRefs.current[37].focus();
        return;
      }

      if (nextRowCellRef) {
        nextRowCellRef.focus();
        nextRowCellRef.select();
      } else {
        setTimeout(() => {
          // // ;
          const nextRowIndex = rowIndex - 1;
          let nextRowCellId = `MrpPrc-td-${nextRowIndex}`;
          let nextRowCell = document.getElementById(nextRowCellId);

          if (!nextRowCell) {
            nextRowCellId = `TotalAmt-td-${nextRowIndex}`;
            nextRowCell = document.getElementById(nextRowCellId);
          }
          if (!nextRowCell) {
            nextRowCellId = `SalePrft-td-${nextRowIndex}`;
            nextRowCell = document.getElementById(nextRowCellId);
          }

          if (!nextRowCell) {
            nextRowCellId = `BrkgAmt-td-${nextRowIndex}`;
            nextRowCell = document.getElementById(nextRowCellId);
          }
          if (!nextRowCell) {
            nextRowCellId = `BrkgPer-td-${nextRowIndex}`;
            nextRowCell = document.getElementById(nextRowCellId);
          }

          if (nextRowCell) {
            nextRowCell.focus();
          }
        }, 10);
      }
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key == "Escape" && Offescpback == 2) {
        setModalOpen(false);
        setModalOpen3(false);
        setLensPowerItem({});
        setLensPowerModalOpen(false);
        setLensPowerItemRowindex();
        setOffescback(1);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [Offescpback]);

  const handleProductKeydownForSuggestion = async (
    event,
    rowIndex,
    columnIndex,
    rowIndex1
  ) => {
    if (event.key === "ArrowDown") {
      if (columnIndex === 7) {
        setHighlightedIndex7((prev) => Math.min(prev + 1, 11));
      } else if (columnIndex === 8) {
        setHighlightedIndex8((prev) => Math.min(prev + 1, 11));
      } else if (columnIndex === 9) {
        setHighlightedIndex9((prev) => Math.min(prev + 1, 11));
      } else if (columnIndex === 10) {
        setHighlightedIndex10((prev) => Math.min(prev + 1, 11));
      } else if (columnIndex === 11) {
        setHighlightedIndex11((prev) => Math.min(prev + 1, 11));
      }
    }
    if (event.key === "ArrowUp") {
      if (columnIndex === 7) {
        setHighlightedIndex7((prev) => Math.max(prev - 1, 0));
      } else if (columnIndex === 8) {
        setHighlightedIndex8((prev) => Math.max(prev - 1, 0));
      } else if (columnIndex === 9) {
        setHighlightedIndex9((prev) => Math.max(prev - 1, 0));
      } else if (columnIndex === 10) {
        setHighlightedIndex10((prev) => Math.max(prev - 1, 0));
      } else if (columnIndex === 11) {
        setHighlightedIndex11((prev) => Math.max(prev - 1, 0));
      }
    }

    if (event.key === "Enter") {
      // 
      if (columnIndex == 8) {
        var item = PowerRangeSPH[rowIndex]?.PowerRangeSPHList.filter(
          (element, index) => index === highlightedIndex8
        );
        handlePowerSelection(
          event,
          rowIndex,
          item[0],
          event.target.name,
          item[0],
          rowIndex1
        );
      } else if (columnIndex == 7) {
        var item = PowerRangeEYE[rowIndex]?.PowerRangeEYEList.filter(
          (element, index) => index === highlightedIndex7
        );
        handlePowerSelection(
          event,
          rowIndex,
          item[0] || event.target.value,
          event.target.name,
          item[0],
          rowIndex1
        );
      } else if (columnIndex == 9) {
        var item = PowerRangeCYL[rowIndex]?.PowerRangeCYLList.filter(
          (element, index) => index === highlightedIndex9
        );
        handlePowerSelection(
          event,
          rowIndex,
          item[0],
          event.target.name,
          item[0],
          rowIndex1
        );
      } else if (columnIndex == 10) {
        var item = PowerRangeAXIS[rowIndex]?.PowerRangeAXISList.filter(
          (element, index) => index === highlightedIndex10
        );
        handlePowerSelection(
          event,
          rowIndex,
          item[0],
          event.target.name,
          item[0],
          rowIndex1
        );
      } else if (columnIndex == 11) {
        var item = PowerRangeADD[rowIndex]?.PowerRangeADDList.filter(
          (element, index) => index === highlightedIndex11
        );
        handlePowerSelection(
          event,
          rowIndex,
          item[0],
          event.target.name,
          item[0],
          rowIndex1
        );
      }
    }

    setTimeout(() => {
      handleProductRowKeyDown(event, rowIndex, columnIndex);
    }, 100);
  };

  const debouncedSaveMethod = useCallback(
    debounce((e, rowIndex1, rowIndex2) => {
      console.log("debouncedSaveMethod");
      onChangeProductSaveMethod(e, rowIndex1, rowIndex2);
    }, 300),
    [onChangeProductSaveMethod]
  );

  useEffect(() => {
    return () => {
      debouncedSaveMethod.cancel?.();
    };
  }, [debouncedSaveMethod]);

  //---------------Auto-suggestion Change-----------------------

  // const handleKeyDown_ProductSuggestion = (e, rowIndex) => {
  //   // // // ;
  //   const { filteredProduct, highlightedIndex } = itemMasterList[rowIndex];
  //   if (!filteredProduct.length) {
  //     handleProductRowKeyDown(e, rowIndex, 3);
  //     return;
  //   }

  //   switch (e.key) {
  //     case "ArrowDown":
  //       e.preventDefault();
  //       setItemMasterList((prevRows) => {
  //         const newRows = [...prevRows];
  //         newRows[rowIndex].highlightedIndex =
  //           (highlightedIndex + 1) % filteredProduct.length;
  //         return newRows;
  //       });
  //       setHighlightedIndex(
  //         (prevIndex) => (prevIndex + 1) % filteredProduct.length // +1 for "Add New" option
  //       );
  //       break;
  //     case "ArrowUp":
  //       e.preventDefault();
  //       setItemMasterList((prevRows) => {
  //         const newRows = [...prevRows];
  //         newRows[rowIndex].highlightedIndex =
  //           highlightedIndex === 0
  //             ? filteredProduct.length - 1
  //             : highlightedIndex - 1;
  //         return newRows;
  //       });
  //       setHighlightedIndex((prevIndex) =>
  //         prevIndex === 0 ? filteredProduct.length : prevIndex - 1
  //       );
  //       break;
  //     case "Enter":
  //       e.preventDefault();
  //       if (
  //         highlightedIndex >= 0 &&
  //         highlightedIndex < filteredProduct.length
  //       ) {
  //         handleProductSelection(rowIndex, filteredProduct[highlightedIndex]);
  //       }
  //       break;
  //     case "Escape":
  //       setItemMasterList((prevRows) => {
  //         const newRows = [...prevRows];
  //         newRows[rowIndex].isDropdownOpen = false;
  //         return newRows;
  //       });
  //       break;
  //     default:
  //       break;
  //   }
  // };

  //---------------Auto-suggestion Change-----------------------

  const handleKeyDown_ProductGroupSuggestion = (e, rowIndex) => {
    // Validate `rowIndex`

    if (rowIndex < 0 || rowIndex >= itemMasterRows.length) {
      console.error("Invalid rowIndex:", rowIndex);
      return;
    }

    // Safely access the row
    const row = itemMasterRows[rowIndex];
    if (!row) {
      console.error("Undefined row at index:", rowIndex);
      return;
    }

    const { filteredProduct = [], highlightedIndex = 0 } = row;

    // Handle empty product list
    if (!filteredProduct.length) {
      handleProductRowKeyDown(e, rowIndex, 2);
      // return;
    }

    switch (e.key) {
      case "ArrowDown":
        if (
          !itemGroupMasterList[rowIndex] ||
          !itemGroupMasterList[rowIndex].isDropdownOpen
        ) {
          return;
        }
        e.preventDefault();
        setitemGroupMasterList((prevRows) => {
          const newRows = [...prevRows];
          const currentHighlightedIndex =
            newRows[rowIndex]?.highlightedIndex || 0;
          // newRows[rowIndex].highlightedIndex =
          //   (highlightedIndex + 1) % filteredProduct.length;
          const totalItems = newRows[rowIndex].filteredProduct.length || 0;
          newRows[rowIndex].highlightedIndex =
            (currentHighlightedIndex + 1) % totalItems;
          return newRows;
        });
        // setHighlightedIndex((prevIndex) => prevIndex + 1);

        setHighlightedIndex((prevIndex) => {
          const totalItems =
            itemGroupMasterList[rowIndex]?.filteredProduct.length || 0;
          let newIndex = prevIndex + 1;

          // Reset to -1 if newIndex exceeds the totalItems
          if (newIndex >= totalItems) {
            newIndex = -1;
          }

          return newIndex;
        });

        break;

      case "ArrowUp":
        if (
          !itemGroupMasterList[rowIndex] ||
          !itemGroupMasterList[rowIndex].isDropdownOpen
        ) {
          return;
        }
        e.preventDefault();
        setitemGroupMasterList((prevRows) => {
          const newRows = [...prevRows];
          const currentHighlightedIndex =
            newRows[rowIndex]?.highlightedIndex || 0;
          const totalItems = newRows[rowIndex].filteredProduct.length || 0;
          // newRows[rowIndex].highlightedIndex =
          //   currentHighlightedIndex === 0
          //     ? filteredProduct.length - 1
          //     : currentHighlightedIndex - 1;
          if (totalItems > 0) {
            newRows[rowIndex].highlightedIndex =
              (currentHighlightedIndex - 1 + totalItems) % totalItems;
          }
          return newRows;
        });
        // setHighlightedIndex((prevIndex) =>
        //   prevIndex === 0 ? filteredProduct.length - 1 : prevIndex - 1
        // );

        setHighlightedIndex((prevIndex) => {
          const totalItems =
            itemGroupMasterList[rowIndex]?.filteredProduct.length || 0;
          let newIndex = prevIndex - 1;

          // If newIndex is less than 0, reset to the last item
          if (newIndex < 0) {
            newIndex = totalItems - 1; // Reset to the last item when the index goes below 0
          }

          return newIndex;
        });

        break;

      case "Enter":
        e.preventDefault();
        if (
          highlightedIndex >= 0 &&
          highlightedIndex <
            itemGroupMasterList[rowIndex]?.filteredProduct.length
        ) {
          handleProductGroupSelection(
            rowIndex,
            itemGroupMasterList[rowIndex].filteredProduct[
              itemGroupMasterList[rowIndex].highlightedIndex
            ]
          );
        }
        break;

      case "Escape":
        setitemGroupMasterList((prevRows) => {
          const newRows = [...prevRows];
          newRows[rowIndex].isDropdownOpen = false;
          return newRows;
        });
        break;

      default:
        break;
    }
  };

  const handleKeyDown_ProductSuggestion = (e, rowIndex, rowindex1) => {
    // Validate `rowIndex`

    setTimeout(() => {
      // ;
      if (rowIndex < 0 || rowIndex >= itemMasterRows.length) {
        console.error("Invalid rowIndex:", rowIndex);
        return;
      }

      // Safely access the row
      const row = itemMasterRows[rowIndex];
      if (!row) {
        console.error("Undefined row at index:", rowIndex);
        return;
      }

      const { filteredProduct = [], highlightedIndex = 0 } = row;

      // Handle empty product list
      if (!filteredProduct.length) {
        handleProductRowKeyDown(e, rowIndex, 3);
        // return;
      }

      switch (e.key) {
        case "ArrowDown":
          if (
            !itemMasterList[rowIndex] ||
            !itemMasterList[rowIndex].isDropdownOpen
          ) {
            return;
          }
          e.preventDefault();
          setItemMasterList((prevRows) => {
            // ;
            const newRows = [...prevRows];
            // const row = newRows[rowIndex]; // Get the row at rowIndex
            const currentHighlightedIndex =
              newRows[rowIndex]?.highlightedIndex || 0;
            const totalItems = newRows[rowIndex].filteredProduct.length || 0;

            if (totalItems > 0) {
              // Ensure the row and filteredProduct array exist
              // const currentHighlightedIndex = row.highlightedIndex || 0;
              // const totalItems = row.filteredProduct.length || 0;
              newRows[rowIndex].highlightedIndex =
                (currentHighlightedIndex + 1) % totalItems;
            }

            return newRows;
          });

          setHighlightedIndex((prevIndex) => {
            const totalItems =
              itemMasterList[rowIndex]?.filteredProduct.length || 0;
            let newIndex = prevIndex + 1;

            // If newIndex is less than 0, reset to the last item
            if (newIndex >= totalItems) {
              newIndex = newIndex % totalItems; // Reset to the last item when the index goes below 0
            }

            return newIndex;
          });
          break;

        case "ArrowUp":
          if (
            !itemMasterList[rowIndex] ||
            !itemMasterList[rowIndex].isDropdownOpen
          ) {
            return;
          }
          e.preventDefault();
          setItemMasterList((prevRows) => {
            const newRows = [...prevRows];
            const currentHighlightedIndex =
              newRows[rowIndex]?.highlightedIndex || 0;
            const totalItems = newRows[rowIndex].filteredProduct.length || 0;
            // newRows[rowIndex].highlightedIndex =
            //   currentHighlightedIndex === 0
            //     ? filteredProduct.length - 1
            //     : currentHighlightedIndex - 1;
            if (totalItems > 0) {
              newRows[rowIndex].highlightedIndex =
                (currentHighlightedIndex - 1 + totalItems) % totalItems;
            }
            return newRows;
          });
          // setHighlightedIndex((prevIndex) =>
          //   prevIndex === 0 ? filteredProduct.length - 1 : prevIndex - 1
          // );

          setHighlightedIndex((prevIndex) => {
            const totalItems =
              itemMasterList[rowIndex]?.filteredProduct.length || 0;
            let newIndex = prevIndex - 1;

            // If newIndex is less than 0, reset to the last item
            if (newIndex < 0) {
              newIndex = totalItems - 1; // Reset to the last item when the index goes below 0
            }

            return newIndex;
          });

          break;

        case "Enter":
          e.preventDefault();
          if (e.target.name != "productName") {
            // highlightedIndex >= 0 && highlightedIndex < filteredProduct.length;
          } else {
            // ;
            if (
              highlightedIndex >= 0 &&
              highlightedIndex <
                itemMasterList[rowIndex]?.filteredProduct.length
            ) {
              handleProductSelection(
                rowIndex,
                itemMasterList[rowIndex].filteredProduct[
                  itemMasterList[rowIndex].highlightedIndex
                ],
                e,
                rowindex1
              );
            }
          }
          break;

        case "Escape":
          setItemMasterList((prevRows) => {
            const newRows = [...prevRows];
            newRows[rowIndex].isDropdownOpen = false;
            return newRows;
          });
          break;

        default:
          break;
      }
    }, 100);
  };

  const [isSliderOpen, setSliderOpen] = useState(false);
  const [SelectedItem, setSelectedItem] = useState({});
  const [showFirstComponent, setShowFirstComponent] = useState(true);

  const AddProductWithlensItem = (item) => {
    ;
    setSliderOpen(true);
    setSelectedItem(item);
    setShowFirstComponent(true);
  };

  const closeAddItemMOdal = () => {
    setSliderOpen(false);
    setSelectedItem({});
    setShowFirstComponent(false);
  };

  //---------------Fill Column Setting (Load Event)-----------------------

  const handleHideAndShow_Column = (e, col_Id, col_Name) => {
    ;
    const { name, checked } = e.target;
    console.log(`Changing ${name} to ${checked}`);

    const updatedValues = {
      ...TransColumnCb,
      [name]: checked,
    };

    setTransColumnCb(updatedValues);

    // Update TransColumnSet
    setTransColumn((prevState) => {
      const columnIndex = prevState.findIndex(
        (column) => column.colId === col_Id
      );
      if (columnIndex > -1) {
        // Update existing column
        const updatedColumns = prevState.map((column, index) =>
          index === columnIndex
            ? { ...column, colShow: checked, colName: col_Name }
            : column
        );
        return updatedColumns;
      } else {
        // Add new column
        const newColumn = {
          masterType: 218,
          transType: TransType,
          transName: TransName,
          colId: col_Id,
          colName: col_Name,
          colShow: checked,
          colWidth: 0,
          colType: "",
          extraField1: "",
          extraField2: "",
          extraField3: "",
        };
        return [...prevState, newColumn];
      }
    });
  };

  const handleWidth_Column = (e, col_Id) => {
    const { name, checked } = e.target;
    console.log(`Changing ${name} to ${checked}`);

    setTransColumn((prevState) =>
      prevState.map((column) =>
        column.colId === col_Id
          ? { ...column, colWidth: e.target.value }
          : column
      )
    );
  };

  useEffect(() => {
    console.log(TransColumnSet);
  }, [TransColumnSet]);

  //--------------- Save Column Setting -----------------------

  const SaveBtnClick = async () => {
    ;
    const pageNo = document.getElementById("setNoOfRows").value;
    if (pageNo) {
      setItemPerPage(pageNo);
    }
    try {
      if (IsExistTransColumnSet) {
        const isSuccess =
          await TransactionTypeSettingAPI.UpdateVoucherWise_ColumnSettingAsync(
            TransColumnSet
          );
        // ;
        if (isSuccess) {
          fetchAllList();
          setLoading(false);
          // alert("update");
          console.log("updated");
        } else {
          setLoading(false);
          alert("error while updating");
        }
      } else {
        const isSuccess =
          await TransactionTypeSettingAPI.CreateVoucherWise_ColumnSettingAsync(
            TransColumnSet
          );
        if (isSuccess) {
          // alert("save");
          fetchAllList();
          setLoading(false);
          setTimeout(() => {
            setIsExistTransColumn(true);
          }, 1000);
        } else {
          alert("error while updating");
        }
      }
    } catch (e) {}

    hideModal3();
  };

  const [paginatedRows, setPaginatedRows] = useState([]);

  useEffect(() => {
    const paginatedRows = itemMasterRows.slice(
      (pageNo - 1) * ItemPerPage,
      pageNo * ItemPerPage
    );
    setPaginatedRows(paginatedRows);
  }, [itemMasterRows, pageNo, ItemPerPage]);

  return (
    <div style={{ position: "relative" }}>
      <div>
        {isItemWiseList && (
          <ItemWiseBatchList
            hideModal6={hideModalOpen61}
            handleModalClick={handleModalClick}
          />
        )}

        <div
          className="table-container-s1 hideInMobile"
          style={{ marginBottom: "30px" }}
        >
          <table className="table-scrol3" style={{ width: "100%" }}>
            <thead className="table-tbody">
              <tr className="table-tr2">
                <th className=" table-th-1 tb_1 c-w-number">
                  <label className="c-w-number">SN</label>
                </th>
                {TransColumnCb.isInputVisible1 && (
                  <th className="mb_1 tb_1 c-w" id="Code-th">
                    {" "}
                    <div className="c-w">BarCode (?)</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible2 && (
                  <th className="mb_2 tb_1 c-w " id="ItemGroup-th">
                    {" "}
                    <div className="c-w">Group</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible3 && (
                  <th
                    className="mb_3 tb_1 c-w"
                    id="ItemName-th"
                    style={{ minWidth: "250px" }}
                  >
                    {" "}
                    <div className="thm2 tb_1 c-w">
                      <label className="c-w" onDoubleClick={openAddItemModal}>
                        Item <span style={{ color: "red" }}>N</span>ame
                      </label>
                    </div>{" "}
                  </th>
                )}
                {TransColumnCb.isInputVisible4 && (
                  <th className="mb_4 tb_1 c-w" id="MasterDescription-th">
                    {" "}
                    <div className="c-w">Description</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible5 && (
                  <th className="mb_5 tb_1 c-w" id="Unit-th">
                    {" "}
                    <div className="c-w">Unit</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible6 && (
                  <th className="mb_6 tb_1 c-w-number" id="Dia-th">
                    {" "}
                    <div className="c-w-number">DIA</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible7 && (
                  <th className="mb_7 tb_1 c-w-number" id="Eye-th">
                    {" "}
                    <div className="c-w-number">EYE</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible8 && (
                  <th className="mb_8 tb_1 c-w-number" id="Sph-th">
                    {" "}
                    <div className="c-w-number">SPH</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible9 && (
                  <th className="mb_9 tb_1 c-w-number" id="Cyl-th">
                    {" "}
                    <div className="c-w-number">CYL</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible10 && (
                  <th className="mb_10 tb_1 c-w-number" id="Axis-th">
                    {" "}
                    <div className="c-w-number">AXIS</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible11 && (
                  <th className="mb_11 tb_1 c-w-number" id="Add-th">
                    {" "}
                    <div className="c-w-number">ADD</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible12 && (
                  <th className="mb_12 tb_1 c-w" id="Attribute1-th">
                    {" "}
                    <div className="c-w">Attribute1</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible13 && (
                  <th className="mb_13 tb_1 c-w" id="Attribute2-th">
                    {" "}
                    <div className="c-w">Attribute2</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible14 && (
                  <th className="mb_14 tb_1 c-w" id="Attribute3-th">
                    {" "}
                    <div className="c-w">Attribute3</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible15 && (
                  <th className="mb_15 tb_1 c-w" id="Attribute4-th">
                    {" "}
                    <div className="c-w">Attribute4</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible16 && (
                  <th className="mb_16 tb_1 c-w" id="Attribute5-th">
                    {" "}
                    <div className="c-w">Attribute5</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible17 && (
                  <th className="mb_17 tb_1 c-w" id="Note1-th">
                    {" "}
                    <div className="c-w">Note1</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible18 && (
                  <th className="mb_18 tb_1 c-w" id="Note2-th">
                    {" "}
                    <div className="c-w">Note2</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible19 && (
                  <th className="mb_19 tb_1 c-w" id="BatchNo-th">
                    {" "}
                    <div className="c-w">Batch No</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible20 && (
                  <th
                    className="mb_20 tb_1 c-w"
                    id="MgfDt-th"
                    style={{ minWidth: "115px" }}
                  >
                    {" "}
                    <div className="c-w">Mgf Dt</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible21 && (
                  <th
                    className="mb_21 tb_1 c-w"
                    id="ExpDt-th"
                    style={{ minWidth: "115px" }}
                  >
                    {" "}
                    <div className="c-w">Exp Dt</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible22 && (
                  <th className="mb_22 tb_1 c-w-number" id="Qty-th">
                    {" "}
                    <div className="c-w-number">Qty</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible23 && (
                  <th className="mb_23 tb_1 c-w-number" id="FreeQty-th">
                    {" "}
                    <div className="c-w-number">Free Qty</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible24 && (
                  <th className="mb_24 tb_1 c-w" id="Price-th">
                    {" "}
                    <div className="c-w">Price</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible25 && (
                  <th className="mb_25 tb_1 c-w-number" id="DiscPer-th">
                    {" "}
                    <div className="c-w-number">Dis%</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible26 && (
                  <th className="mb_26 tb_1 c-w" id="DoubleDis-th">
                    {" "}
                    <div className="c-w">Double Dis%</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible27 && (
                  <th className="mb_27 tb_1 c-w" id="DiscAmt-th">
                    {" "}
                    <div className="c-w">Dis Amt</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible29 && (
                  <th className="mb_29 tb_1 c-w" id="SalePrc-th">
                    {" "}
                    <div className="c-w">Sale Prc</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible30 && (
                  <th className="mb_30 tb_1 c-w" id="SalePrft-th">
                    {" "}
                    <div className="c-w">Sale Prft</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible31 && (
                  <th className="mb_31 tb_1 c-w" id="MrpPrc-th">
                    {" "}
                    <div className="c-w">MRP Prc</div>
                  </th>
                )}
        
                {TransColumnCb.isInputVisible32 && (
                  <th className="mb_32 tb_1 c-w" id="BrkrName-th">
                    {" "}
                    <div className="c-w">Brkr Name</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible33 && (
                  <th className="mb_33 tb_1 c-w" id="BrkgPer-th">
                    {" "}
                    <div className="c-w">Brkg%</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible34 && (
                  <th className="mb_34 tb_1 c-w" id="BrkgAmt-th">
                    {" "}
                    <div className="c-w">Brkg Amt</div>
                  </th>
                )}
                {TransColumnCb.isInputVisible35 && (
                  <th className="mb_34 tb_1 c-w" id="CGST-th">
                    {" "}
                    <div className="c-w">CGST</div>
                  </th>
                )}{" "}
                {TransColumnCb.isInputVisible36 && (
                  <th className="mb_34 tb_1 c-w" id="IGST-VAT-th">
                    {" "}
                    <div className="c-w">IGST / VAT</div>
                  </th>
                )}{" "}
                {TransColumnCb.isInputVisible37 && (
                  <th className="mb_34 tb_1 c-w" id="SGST-th">
                    {" "}
                    <div className="c-w">SGST</div>
                  </th>
                )}{" "}
                {TransColumnCb.isInputVisible38 && (
                  <th className="mb_34 tb_1 c-w" id="TaxRate-th">
                    {" "}
                    <div className="c-w">TaxRate</div>
                  </th>
                )}{" "}
                {TransColumnCb.isInputVisible39 && (
                  <th className="mb_34 tb_1 c-w" id="TaxableAmount-th">
                    {" "}
                    <div className="c-w">Taxable Amount</div>
                  </th>
                )}
                        {/* {TransColumnCb.isInputVisible28 && ( */}
                  <th className="mb_28 tb_1 c-w" id="TotalAmt-th">
                    {" "}
                    <div className="c-w">Total Amt</div>
                  </th>
                {/* )} */}
                {/*{TransColumnCb.isInputVisible35 && (<th className="mb_35 tb_1 c-w" id="customeFields-th"> <div className="c-w">{customfields[0].FieldName}</div></th>)}*/}
                {(() => {
                  if (customfields.length !== 0) {
                    return customfields.map(
                      (fields, index) =>
                        TransColumnCb[`isInputVisible${fields.id + 34}`] && (
                          <th
                            className={`mb_${fields.id + 34} tb_1 c-w`}
                            id={`customeFields${fields.id}-th`}
                          >
                            <div className="c-w">
                              {customfields[index].FieldName}
                            </div>
                          </th>
                        )
                    );
                  }
                })()}
                <th
                  className="table-th table-btn table-btn1 c-w"
                  onClick={showModal3}
                >
                  <i
                    className="fa-solid fa-gear settingIcon"
                    style={{ display: "block" }}
                  ></i>
                </th>
              </tr>
            </thead>

            <tbody
              className="table-container-tbody1"
              // style={{ height: "130px", overflowx: "scroll" }}
            >
              {itemMasterRows &&
                itemMasterRows.length > 0 &&
                itemMasterRows.map((row, rowIndex) => (
                  <tr
                    className={`table-tr2 hover-tr onSerialNoHover ${
                      rowIndex === hoveredRow ? "hovered-row" : ""
                    }`}
                    key={rowIndex}
                    onMouseEnter={() => handleRowHover(rowIndex)}
                    onMouseLeave={handleRowLeave}
                    style={{ textAlign: "center" }}
                  >
                    <td
                      className="table-th-1 c-w-number"
                      onClick={() => addRowAtBetween(rowIndex)}
                      onDoubleClick={() => lensPowerModal(row, rowIndex)}
                    >
                      {rowIndex + 1 + ItemPerPage * (pageNo - 1)}
                    </td>
                    {TransColumnCb.isInputVisible1 && (
                      <td className="mb_1">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="defaultBarcode"
                          style={{ textAlign: "left", paddingLeft: "5px" }}
                          value={row.defaultBarcode || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            fetchDataForSerialNo(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 1)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][1] = input;
                          }}
                          id={`Code-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible2 && (
                      <td className="mb_2">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          name="parentGrpName"
                          style={{ textAlign: "left", paddingLeft: "5px" }}
                          value={row.parentGrpName || ""}
                          autoComplete="off"
                          onChange={(e) => {
                            debouncedOpenSuggestionItemGroup(e, rowIndex);
                            handleInputChange(e, rowIndex, row.rowIndex);
                          }}
                          onBlur={(e) => {
                            if (itemGroupMasterList[rowIndex]) {
                              itemGroupMasterList[
                                rowIndex
                              ].isDropdownOpen = false;
                            }
                            debouncedSaveMethod(e, row.rowIndex, rowIndex);
                          }}
                          onKeyUp={(e) =>
                            handleKeyDown_ProductGroupSuggestion(e, rowIndex)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][2] = input;
                          }}
                          id={`Group-td-${rowIndex}`}
                          onClick={() => getPosition(rowIndex, 2)} // Get position on click
                        />

                        {itemGroupMasterList[rowIndex]?.isDropdownOpen && (
                          <ul
                            className="ItemmasterDuggestionsaleinvoice"
                            ref={suggestionBoxRef}
                            style={{
                              top: `${inputPosition.top}px`,
                              left: `${inputPosition.left}px`,
                              // width: `${inputPosition.width}px`,
                            }}
                          >
                            {itemGroupMasterList[rowIndex].filteredProduct.map(
                              (item, index) => (
                                <li
                                  key={item.id2}
                                  onClick={() => {
                                    preventBlur = true;
                                    handleProductGroupSelection(rowIndex, item);

                                    if (
                                      nextCellRefsProduct.current[rowIndex]?.[2]
                                    ) {
                                      nextCellRefsProduct.current[
                                        rowIndex
                                      ][2].focus();
                                    }

                                    setTimeout(() => {
                                      preventBlur = false;
                                    }, 0);
                                  }}
                                  ref={(el) => (itemRefs.current[index] = el)}
                                  style={{
                                    backgroundColor:
                                      itemGroupMasterList[rowIndex]
                                        .highlightedIndex === index
                                        ? "#e6f7ff"
                                        : "transparent",
                                  }}
                                >
                                  {item.name}
                                </li>
                              )
                            )}

                            <li
                              key={
                                itemGroupMasterList[rowIndex].filteredProduct
                                  .length
                              }
                              ref={(el) =>
                                (itemRefs.current[
                                  itemGroupMasterList[
                                    rowIndex
                                  ].filteredProduct.length
                                ] = el)
                              }
                              className="addNew_btn_saleInvoice"
                              onClick={() => openGroupModal(row)}
                              style={{
                                cursor: "pointer",
                                borderBottom: "1px solid #ccc",
                                backgroundColor:
                                  highlightedIndex ===
                                  itemGroupMasterList[rowIndex].filteredProduct
                                    ? "black"
                                    : "#5e709e",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {" "}
                              Add New Group
                              <i class="fa-solid fa-plus"></i>
                            </li>
                          </ul>
                        )}
                      </td>
                    )}
                    {TransColumnCb.isInputVisible3 && (
                      <td className="mb_3" style={{ minWidth: "250px" }}>
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          style={{ textAlign: "left", paddingLeft: "5px" }}
                          name="productName"
                          autoComplete="off"
                          value={row.productName || ""}
                          onKeyUp={(e) =>
                            handleKeyDown_ProductSuggestion(
                              e,
                              rowIndex,
                              row.rowIndex
                            )
                          }
                          onChange={(e) => {
                            debouncedHandleProductNameChange(
                              e,
                              rowIndex,
                              ShowMainProductOnlyInItemSuggestion
                            );
                            handleInputChange(e, rowIndex, row.rowIndex);
                          }}
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][3] = input;
                          }}
                          onBlur={() => {
                            RemoveSuggestion(rowIndex);
                          }}
                          // onBlur={() => {
                          //   if (!preventBlur && itemMasterList[rowIndex]) {
                          //     itemMasterList[rowIndex].isDropdownOpen = false;
                          //   }
                          // }}
                          id={`ItemName-td-${rowIndex}`}
                          onClick={() => {
                            getPosition(rowIndex, 3);
                            // handleProductNameChange(
                            //   { target: { value: "" } },
                            //   rowIndex
                            // );
                          }} // Get position on click
                        />
                        {itemMasterList[rowIndex]?.isDropdownOpen && (
                          <ul
                            className="ItemmasterDuggestionsaleinvoice"
                            ref={suggestionBoxRef}
                            style={{
                              top: `${inputPosition.top}px`,
                              left: `${inputPosition.left}px`,
                              width: `${inputPosition.width}px`,
                            }}
                          >
                            {itemMasterList[rowIndex]?.filteredProduct.map(
                              (item, index) => (
                                <li
                                  key={item.id2}
                                  onClick={(e) => {
                                    preventBlur = true;
                                    handleDebouncedSelection(
                                      rowIndex,
                                      item,
                                      e,
                                      row.rowIndex
                                    );
                                    if (
                                      nextCellRefsProduct.current[rowIndex]?.[3]
                                    ) {
                                      nextCellRefsProduct.current[
                                        rowIndex
                                      ][3].focus();
                                    }
                                    setTimeout(() => {
                                      preventBlur = false;
                                    }, 0);
                                  }}
                                  ref={(el) => (itemRefs.current[index] = el)}
                                  style={{
                                    backgroundColor:
                                      itemMasterList[rowIndex]
                                        .highlightedIndex === index
                                        ? "#e6f7ff"
                                        : "transparent",
                                  }}
                                >
                                  {item.name}
                                </li>
                              )
                            )}
                          </ul>
                        )}
                        <input
                          type="hidden"
                          name="parentGrp"
                          value={row.parentGrp}
                        />
                        <input
                          type="hidden"
                          name="productUnit"
                          value={row.productUnit}
                        />
                        <input
                          type="hidden"
                          name="productAltUnit"
                          value={row.productAltUnit}
                        />
                        <input
                          type="hidden"
                          name="unitConvFactor"
                          value={row.unitConvFactor}
                        />
                        <input
                          type="hidden"
                          name="mrpPrice"
                          value={row.mrpPrice}
                        />
                        <input
                          type="hidden"
                          name="amt_after_discount"
                          value={row.amt_after_discount}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible4 && (
                      <td className="mb_4">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          name="shortDescription"
                          autoComplete="off"
                          value={row.shortDescription || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 4)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][4] = input;
                          }}
                          id={`MasterDescription-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible5 && (
                      <td className="mb_5">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          name="productUnitName"
                          value={row.productUnitName || ""}
                          autoComplete="off"
                          onChange={(e) => {
                            debouncedOpenSuggestionUnit(e, rowIndex);
                            handleInputChange(e, rowIndex, row.rowIndex);
                          }}
                          onBlur={() => {
                            if (units[rowIndex]) {
                              units[rowIndex].isDropdownOpen = false;
                            }
                          }}
                          onKeyUp={(e) =>
                            handleKeyDown_UnitSuggestion(e, rowIndex, 5)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][5] = input;
                          }}
                          id={`Unit-td-${rowIndex}`}
                        />
                        {units[rowIndex]?.isDropdownOpen && (
                          <ul
                            className="ItemmasterDuggestionsaleinvoice"
                            ref={suggestionBoxRef}
                            style={{
                              top: `${inputPosition.top}px`,
                              left: `${inputPosition.left}px`,
                              // width: `${inputPosition.width}px`,
                            }}
                          >
                            {units[rowIndex]?.filteredProduct.map(
                              (item, index) => (
                                <li
                                  key={item.id}
                                  onClick={() => {
                                    preventBlur = true;
                                    handleUnitSelection(rowIndex, item);
                                    if (
                                      nextCellRefsProduct.current[rowIndex]?.[5]
                                    ) {
                                      nextCellRefsProduct.current[
                                        rowIndex
                                      ][5].focus();
                                    }

                                    // Reset preventBlur after the click is processed
                                    setTimeout(() => {
                                      preventBlur = false;
                                    }, 0);
                                  }}
                                  ref={(el) => (itemRefs.current[index] = el)}
                                  style={{
                                    backgroundColor:
                                      units[rowIndex].highlightedIndex === index
                                        ? "#e6f7ff"
                                        : "transparent",
                                  }}
                                >
                                  {item.name}
                                </li>
                              )
                            )}
                          </ul>
                        )}
                      </td>
                    )}

                    {TransColumnCb.isInputVisible6 && (
                      <td className="mb_6 c-w-number">
                        <input
                          className="table-input-13 pd_1 c-w-number"
                          type="text"
                          name="lens_Dia"
                          autoComplete="off"
                          value={row.lens_Dia || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 6)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][6] = input;
                          }}
                          id={`Dia-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible7 && (
                      <td className="mb_7 c-w-number">
                        <input
                          className="table-input-13 pd_1 c-w-number"
                          type="text"
                          name="lens_Eye"
                          autoComplete="off"
                          value={row.lens_Eye || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) => {
                            closeSuggestionAll(e, row.rowIndex, rowIndex);
                          }}
                          onClick={() => getPosition(rowIndex, 7)} // Get position on click
                          onKeyUp={(e) =>
                            handleProductKeydownForSuggestion(
                              e,
                              rowIndex,
                              7,
                              row.rowIndex
                            )
                          }
                          onFocus={() => getPosition(rowIndex, 7)} // Get position on click
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][7] = input;
                          }}
                          id={`Eye-td-${rowIndex}`}
                        />
                        {/* {PowerRangeEYE.length >= rowIndex && (
                        <> */}
                        {(PowerRangeEYE[rowIndex]?.PowerRangeEYEShow ||
                          false) && (
                          <ul
                            className="ItemmasterDuggestionsaleinvoice"
                            ref={suggestionBoxRef}
                            style={{
                              top: `${inputPosition.top}px`,
                              left: `${inputPosition.left}px`,
                              width: `${inputPosition.width}px`,
                            }}
                          >
                            {PowerRangeEYE[rowIndex]?.PowerRangeEYEList.map(
                              (item, index) => (
                                <li
                                  key={item.id2}
                                  onClick={(event) =>
                                    handlePowerSelection(
                                      event,
                                      rowIndex,
                                      "",
                                      "lens_Eye",
                                      item,
                                      row.rowIndex
                                    )
                                  }
                                  ref={(el) => (itemRefs.current[index] = el)}
                                  style={{
                                    backgroundColor:
                                      highlightedIndex7 === index
                                        ? "#e6f7ff"
                                        : "transparent",
                                  }}
                                >
                                  {item}
                                </li>
                              )
                            )}
                          </ul>
                        )}
                        {/* </>
                      )} */}
                      </td>
                    )}
                    {TransColumnCb.isInputVisible8 && (
                      <td className="mb_8 c-w-number">
                        <input
                          className="table-input-13 pd_1 c-w-number"
                          type="text"
                          autoComplete="off"
                          name="lens_SPH"
                          value={row.lens_SPH || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) => {
                            closeSuggestionAll(e, row.rowIndex, rowIndex);
                          }}
                          onKeyUp={(e) =>
                            handleProductKeydownForSuggestion(
                              e,
                              rowIndex,
                              8,
                              row.rowIndex
                            )
                          }
                          onClick={() => getPosition(rowIndex, 8)} // Get position on click
                          onFocus={() => getPosition(rowIndex, 8)} // Get position on click
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][8] = input;
                          }}
                          id={`Sph-td-${rowIndex}`}
                        />

                        {/* {PowerRangeSPHShow && ("true")} */}
                        {/* {PowerRangeSPH.length >= rowIndex && (
                        <> */}
                        {(PowerRangeSPH[rowIndex]?.PowerRangeSPHShow ||
                          false) && (
                          <ul
                            className="ItemmasterDuggestionsaleinvoice"
                            ref={suggestionBoxRef}
                            style={{
                              top: `${inputPosition.top}px`,
                              left: `${inputPosition.left}px`,
                              width: `${inputPosition.width}px`,
                            }}
                          >
                            {PowerRangeSPH[rowIndex]?.PowerRangeSPHList.map(
                              (item, index) => (
                                <li
                                  key={item.id2}
                                  onClick={(event) =>
                                    handlePowerSelection(
                                      event,
                                      rowIndex,
                                      "",
                                      "lens_SPH",
                                      item,
                                      row.rowIndex
                                    )
                                  }
                                  ref={(el) => (itemRefs.current[index] = el)}
                                  style={{
                                    backgroundColor:
                                      highlightedIndex8 === index
                                        ? "#e6f7ff"
                                        : "transparent",
                                  }}
                                >
                                  {item.toFixed(2)}
                                </li>
                              )
                            )}
                          </ul>
                        )}
                        {/* </>
                      )} */}
                      </td>
                    )}
                    {TransColumnCb.isInputVisible9 && (
                      <td className="mb_9 c-w-number">
                        <input
                          className="table-input-13 pd_1 c-w-number"
                          type="text"
                          autoComplete="off"
                          name="lens_CYL"
                          value={row.lens_CYL || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) => {
                            closeSuggestionAll(e, row.rowIndex, rowIndex);
                          }}
                          onKeyUp={(e) =>
                            handleProductKeydownForSuggestion(
                              e,
                              rowIndex,
                              9,
                              row.rowIndex
                            )
                          }
                          onClick={() => getPosition(rowIndex, 9)} // Get position on click
                          onFocus={() => getPosition(rowIndex, 9)} // Get position on click
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][9] = input;
                          }}
                          id={`Cyl-td-${rowIndex}`}
                        />
                        {/* {PowerRangeCYL.length >= rowIndex && (
                        <> */}
                        {(PowerRangeCYL[rowIndex]?.PowerRangeCYLShow ||
                          false) && (
                          <ul
                            className="ItemmasterDuggestionsaleinvoice"
                            ref={suggestionBoxRef}
                            style={{
                              top: `${inputPosition.top}px`,
                              left: `${inputPosition.left}px`,
                              width: `${inputPosition.width}px`,
                            }}
                          >
                            {PowerRangeCYL[rowIndex]?.PowerRangeCYLList.map(
                              (item, index) => (
                                <li
                                  key={item.id2}
                                  onClick={(event) =>
                                    handlePowerSelection(
                                      event,
                                      rowIndex,
                                      "",
                                      "lens_CYL",
                                      item,
                                      row.rowIndex
                                    )
                                  }
                                  ref={(el) => (itemRefs.current[index] = el)}
                                  style={{
                                    backgroundColor:
                                      highlightedIndex9 === index
                                        ? "#e6f7ff"
                                        : "transparent",
                                  }}
                                >
                                  {item.toFixed(2)}
                                </li>
                              )
                            )}
                          </ul>
                        )}
                        {/* </>
                      )} */}
                      </td>
                    )}
                    {TransColumnCb.isInputVisible10 && (
                      <td className="mb_10 c-w-number">
                        <input
                          className="table-input-13 pd_1 c-w-number"
                          type="text"
                          autoComplete="off"
                          name="lens_AXIS"
                          value={row.lens_AXIS || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) => {
                            closeSuggestionAll(e, row.rowIndex, rowIndex);
                          }}
                          onKeyUp={(e) =>
                            handleProductKeydownForSuggestion(
                              e,
                              rowIndex,
                              10,
                              row.rowIndex
                            )
                          }
                          onClick={() => getPosition(rowIndex, 10)} // Get position on click
                          onFocus={() => getPosition(rowIndex, 10)} // Get position on click
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][10] = input;
                          }}
                          id={`Axis-td-${rowIndex}`}
                        />
                        {/* {PowerRangeAXIS.length <= rowIndex && (
                        <> */}
                        {(PowerRangeAXIS[rowIndex]?.PowerRangeAXISShow ||
                          false) && (
                          <ul
                            className="ItemmasterDuggestionsaleinvoice"
                            ref={suggestionBoxRef}
                            style={{
                              top: `${inputPosition.top}px`,
                              left: `${inputPosition.left}px`,
                              width: `${inputPosition.width}px`,
                            }}
                          >
                            {PowerRangeAXIS[rowIndex]?.PowerRangeAXISList.map(
                              (item, index) => (
                                <li
                                  key={item.id2}
                                  onClick={(event) =>
                                    handlePowerSelection(
                                      event,
                                      rowIndex,
                                      "",
                                      "lens_AXIS",
                                      item,
                                      row.rowIndex
                                    )
                                  }
                                  ref={(el) => (itemRefs.current[index] = el)}
                                  style={{
                                    backgroundColor:
                                      highlightedIndex10 === index
                                        ? "#e6f7ff"
                                        : "transparent",
                                  }}
                                >
                                  {item}
                                </li>
                              )
                            )}
                          </ul>
                        )}
                        {/* </>
                      )} */}
                      </td>
                    )}
                    {TransColumnCb.isInputVisible11 && (
                      <td className="mb_11 c-w-number">
                        <input
                          className="table-input-13 pd_1 c-w-number"
                          type="text"
                          autoComplete="off"
                          name="lens_Add"
                          value={row.lens_Add || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) => {
                            closeSuggestionAll(e, row.rowIndex, rowIndex);
                          }}
                          onKeyUp={(e) =>
                            handleProductKeydownForSuggestion(
                              e,
                              rowIndex,
                              11,
                              row.rowIndex
                            )
                          }
                          onClick={() => getPosition(rowIndex, 11)} // Get position on click
                          onFocus={() => getPosition(rowIndex, 11)} // Get position on click
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][11] = input;
                          }}
                          id={`Add-td-${rowIndex}`}
                        />
                        {(PowerRangeADD[rowIndex]?.PowerRangeADDShow ||
                          false) && (
                          <ul
                            className="ItemmasterDuggestionsaleinvoice"
                            ref={suggestionBoxRef}
                            style={{
                              top: `${inputPosition.top}px`,
                              left: `${inputPosition.left}px`,
                              width: `${inputPosition.width}px`,
                            }}
                          >
                            {PowerRangeADD[rowIndex]?.PowerRangeADDList.map(
                              (item, index) => (
                                <li
                                  key={item.id2}
                                  onClick={(event) =>
                                    handlePowerSelection(
                                      event,
                                      rowIndex,
                                      "",
                                      "lens_Add",
                                      item,
                                      row.rowIndex
                                    )
                                  }
                                  ref={(el) => (itemRefs.current[index] = el)}
                                  style={{
                                    backgroundColor:
                                      highlightedIndex11 === index
                                        ? "#e6f7ff"
                                        : "transparent",
                                  }}
                                >
                                  {item?.toFixed(2)}
                                </li>
                              )
                            )}
                          </ul>
                        )}
                      </td>
                    )}

                    {TransColumnCb.isInputVisible12 && (
                      <td className="mb_12">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="Attribute1"
                          value={row.Attribute1 || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 12)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][12] = input;
                          }}
                          id={`Attribute1-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible13 && (
                      <td className="mb_13">
                        <input
                          className="table-input-13 pd_1"
                          autoComplete="off"
                          type="text"
                          name="Attribute2"
                          value={row.Attribute2 || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 13)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][13] = input;
                          }}
                          id={`Attribute2-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible14 && (
                      <td className="mb_14">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="Attribute3"
                          value={row.Attribute3 || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 14)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][14] = input;
                          }}
                          id={`Attribute3-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible15 && (
                      <td className="mb_15">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="Attribute4"
                          value={row.Attribute4 || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 15)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][15] = input;
                          }}
                          id={`Attribute4-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible16 && (
                      <td className="mb_16">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="Attribute5"
                          value={row.Attribute5 || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 16)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][16] = input;
                          }}
                          id={`Attribute5-td-${rowIndex}`}
                        />
                      </td>
                    )}

                    {TransColumnCb.isInputVisible17 && (
                      <td className="mb_17">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="Note1"
                          value={row.Note1 || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 17)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][17] = input;
                          }}
                          id={`Note1-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible18 && (
                      <td className="mb_18">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="Note2"
                          value={row.Note2 || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 18)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][18] = input;
                          }}
                          id={`Note2-td-${rowIndex}`}
                        />
                      </td>
                    )}

                    {TransColumnCb.isInputVisible19 && (
                      <td className="mb_19">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          name="batchNo"
                          autoComplete="off"
                          value={row.BatchNo || ""}
                          onChange={(e) =>
                            handleBatchdataChange(
                              rowIndex,
                              "batchNo",
                              e.target.value
                            )
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 19)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][19] = input;
                          }}
                          id={`BatchNo-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible20 && (
                      <td className="mb_20">
                        <input
                          className="table-input-13 pd_1"
                          type="date"
                          name="mgfDate"
                          autoComplete="off"
                          value={row.MgfDt || ""}
                          onChange={(e) =>
                            handleBatchdataChange(
                              rowIndex,
                              "mgfDate",
                              e.target.value
                            )
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 20)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][20] = input;
                          }}
                          id={`MgfDt-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible21 && (
                      <td className="mb_21">
                        <input
                          className="table-input-13 pd_1"
                          type="date"
                          autoComplete="off"
                          name="expDate"
                          value={row.ExpDt || ""}
                          onChange={(e) =>
                            handleBatchdataChange(
                              rowIndex,
                              "expDate",
                              e.target.value
                            )
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 21)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][21] = input;
                          }}
                          id={`ExpDt-td-${rowIndex}`}
                        />
                      </td>
                    )}

                    {TransColumnCb.isInputVisible22 && (
                      <td className="mb_22 c-w-number">
                        <input
                          className="table-input-13 pd_1 c-w-number"
                          type="text"
                          name="Qty"
                          autoComplete="off"
                          value={row.Qty || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 22)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][22] = input;
                          }}
                          //onKeyUp={handleKeyDown} BatchPopup
                          id={`Qty-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible23 && (
                      <td className="mb_23 c-w-number">
                        <input
                          className="table-input-13 pd_1 c-w-number"
                          type="text"
                          name="FreeQty"
                          autoComplete="off"
                          value={row.FreeQty || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 23)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][23] = input;
                          }}
                          id={`FreeQty-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible24 && (
                      <td className="mb_24">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="itemPrice"
                          value={row.itemPrice || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            onChangeProductSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 24)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][24] = input;
                          }}
                          id={`Price-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible25 && (
                      <td className="mb_25 c-w-number">
                        <input
                          className="table-input-13 pd_1 c-w-number"
                          type="text"
                          autoComplete="off"
                          name="DiscPer"
                          value={row.DiscPer || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 25)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][25] = input;
                          }}
                          id={`DiscPer-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible26 && (
                      <td className="mb_26">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="DoubleDis"
                          value={row.DoubleDis || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 26)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][26] = input;
                          }}
                          id={`DoubleDis-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible27 && (
                      <td className="mb_27">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="DiscAmt"
                          value={row.DiscAmt || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 27)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][27] = input;
                          }}
                          id={`DiscAmt-td-${rowIndex}`}
                        />
                      </td>
                    )}

                    {TransColumnCb.isInputVisible29 && (
                      <td className="mb_29">
                        <input
                          className="table-input-13 pd_1 "
                          autoComplete="off"
                          type="text"
                          name="purPageSalePrice"
                          value={row.purPageSalePrice || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 28)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][28] = input;
                          }}
                          id={`SalePrc-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible30 && (
                      <td className="mb_30">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          autoComplete="off"
                          name="saleProfit"
                          value={row.saleProfit || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 29)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][29] = input;
                          }}
                          id={`SalePrft-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible31 && (
                      <td className="mb_31">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          autoComplete="off"
                          name="mrpPrice"
                          value={row.mrpPrice || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 30)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][30] = input;
                          }}
                          id={`MrpPrc-td-${rowIndex}`}
                        />
                      </td>
                    )}

                   

                    {TransColumnCb.isInputVisible32 && (
                      <td className="mb_32">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          autoComplete="off"
                          name="BrkrName"
                          value={row.BrkrName || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 32)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][32] = input;
                          }}
                          id={`BrkrName-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible33 && (
                      <td className="mb_33">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          autoComplete="off"
                          name="salesManItemIncentive"
                          value={row.salesManItemIncentive || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 33)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][33] = input;
                          }}
                          id={`BrkgPer-td-${rowIndex}`}
                        />
                      </td>
                    )}
                    {TransColumnCb.isInputVisible34 && (
                      <td className="mb_34">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          name="BrkgAmt"
                          autoComplete="off"
                          value={row.BrkgAmt || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 34)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][34] = input;
                          }}
                          id={`BrkgAmt-td-${rowIndex}`}
                        />
                      </td>
                    )}

                    {TransColumnCb.isInputVisible35 && (
                      <td className="mb_35">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          name="CGST"
                          autoComplete="off"
                          value={row.BrkgAmt || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 35)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][35] = input;
                          }}
                          id={`CGST-td-${rowIndex}`}
                        />
                      </td>
                    )}

                    {TransColumnCb.isInputVisible36 && (
                      <td className="mb_36">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          name="IGST-VAT"
                          autoComplete="off"
                          value={row.BrkgAmt || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 36)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][36] = input;
                          }}
                          id={`IGST-VAT-td-${rowIndex}`}
                        />
                      </td>
                    )}

                    {TransColumnCb.isInputVisible37 && (
                      <td className="mb_37">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          name="SGST"
                          autoComplete="off"
                          value={row.BrkgAmt || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 37)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][37] = input;
                          }}
                          id={`SGST-td-${rowIndex}`}
                        />
                      </td>
                    )}

                    {TransColumnCb.isInputVisible38 && (
                      <td className="mb_38">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          name="TaxRate"
                          autoComplete="off"
                          value={row.BrkgAmt || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 38)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][38] = input;
                          }}
                          id={`TaxRate-td-${rowIndex}`}
                        />
                      </td>
                    )}

                    {TransColumnCb.isInputVisible39 && (
                      <td className="mb_39">
                        <input
                          className="table-input-13 pd_1 "
                          type="text"
                          name="TaxableAmount"
                          autoComplete="off"
                          value={row.BrkgAmt || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            debouncedSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 39)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][39] = input;
                          }}
                          id={`TaxableAmount-td-${rowIndex}`}
                        />
                      </td>
                    )}

                     {/* {TransColumnCb.isInputVisible28 && ( */}
                      <td className="mb_28">
                        <input
                          className="table-input-13 pd_1"
                          type="text"
                          autoComplete="off"
                          name="TotalAmt"
                          // value={row.TotalAmt|| ""}
                          value={
                            row.TotalAmt === null ||
                            row.TotalAmt === undefined ||
                            row.TotalAmt === ""
                              ? ""
                              : parseFloat(row.TotalAmt).toFixed(
                                  currencyDecimalPlaces
                                )
                          }
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, row.rowIndex)
                          }
                          onBlur={(e) =>
                            onChangeProductSaveMethod(e, row.rowIndex, rowIndex)
                          }
                          onKeyUp={(e) =>
                            handleProductRowKeyDown(e, rowIndex, 31)
                          }
                          ref={(input) => {
                            if (!nextCellRefsProduct.current[rowIndex])
                              nextCellRefsProduct.current[rowIndex] = [];
                            nextCellRefsProduct.current[rowIndex][31] = input;
                          }}
                          id={`TotalAmt-td-${rowIndex}`}
                        />
                      </td>
                    {/* )} */}


                    {(() => {
                      if (customfields.length !== 0) {
                        return customfields.map(
                          (fields, index) =>
                            TransColumnCb[
                              `isInputVisible${fields.id + 34}`
                            ] && (
                              <td className={`mb_${fields.id + 34}`}>
                                <input
                                  className="table-input-13 pd_1 "
                                  type="text"
                                  name={`customeFields${fields.id}-${rowIndex}`}
                                  //value={row[`customeFields-${rowIndex}`] || ""}
                                  onChange={(e) =>
                                    handleInputChange(e, rowIndex, row.rowIndex)
                                  }
                                  onBlur={(e) =>
                                    debouncedSaveMethod(e, rowIndex)
                                  }
                                  onKeyDown={(e) =>
                                    handleProductRowKeyDown(
                                      e,
                                      rowIndex,
                                      fields.id
                                    )
                                  }
                                  ref={(input) => {
                                    if (!nextCellRefsProduct.current[rowIndex])
                                      nextCellRefsProduct.current[rowIndex] =
                                        [];
                                    nextCellRefsProduct.current[rowIndex][
                                      fields.id
                                    ] = input;
                                  }}
                                  id={`customeFields${fields.id}-td-${rowIndex}`}
                                />
                              </td>
                            )
                        );
                      }
                    })()}

                    <td
                      className=""
                      style={{ textAlign: "center", width: "maxWidth" }}
                    >
                      <button
                        className="btn-table1"
                        onClick={() => handleDeleteRow(row.rowIndex, rowIndex)}
                      >
                        <i
                          className="fa-solid fa-trash delete-btn "
                          style={{ margin: "0" }}
                        ></i>
                      </button>
                      <button
                        className="btn-table1"
                        onClick={() =>
                          AddProductWithlensItem(row, row.rowIndex, rowIndex)
                        }
                      >
                        {/* <i
                          className="fa-solid fa-square-plus sale-Invoice-plus-button"
                          style={{ margin: "0" }}
                        ></i> */}
                        {/* <i class="fa-solid fa-square-up-right"></i> */}
                        <i
                          style={{ color: "gray", fontSize: "15px" }}
                          class="fa-solid fa-square-arrow-up-right"
                        ></i>
                      </button>
                    </td>
                  </tr>
                ))}
              {/* {itemMasterRows.length >= ItemPerPage && ( */}

              {/* )} */}
            </tbody>
          </table>
        </div>

        {itemMasterRows && (
          <>
            {itemMasterRows[0].productName && (
              <div className="ItemShowingTabMobileBox">
                <p>Item list</p>
                {itemMasterRows.map((item, index) => (
                  <>
                    {item.productName && (
                      <div className="ItemShowingTabMobile">
                        <h1 className="ItemShowingTabMobile-datarow">
                          <label htmlFor="">
                            <span>#{index + 1}</span>
                            Name : {item.productName.toUpperCase()}{" "}
                          </label>
                          <label htmlFor="">
                            {" "}
                            <i class="fa-solid fa-indian-rupee-sign"></i>
                            {item.itemPrice}
                          </label>
                        </h1>
                        <h1 className="ItemShowingTabMobile-datarow">
                          <label htmlFor="">
                            Item Sub Total : (
                            <i class="fa-solid fa-indian-rupee-sign"></i>
                            {item.itemPrice} * {item.Qty})
                          </label>
                          <label htmlFor="">
                            {" "}
                            <i class="fa-solid fa-indian-rupee-sign"></i>
                            {item.itemPrice * item.Qty}
                          </label>
                        </h1>
                        <h1 className="ItemShowingTabMobile-datarow">
                          <label htmlFor="">Discount : ({item.DiscPer}%)</label>
                          <label htmlFor="">
                            <i class="fa-solid fa-indian-rupee-sign"></i>
                            {item.DiscAmt}
                          </label>
                        </h1>
                        <h1
                          style={{ marginTop: "10px" }}
                          className="ItemShowingTabMobile-datarow"
                        >
                          <label
                            htmlFor=""
                            onClick={(e) => handleDeleteRow(index)}
                          >
                            Delete <i class="fa-solid fa-trash"></i>
                          </label>
                          <label
                            htmlFor=""
                            onClick={() => handleEditRow(index)}
                          >
                            Edit <i class="fa-solid fa-pen-to-square"></i>
                          </label>
                        </h1>
                      </div>
                    )}
                  </>
                ))}
              </div>
            )}
            <div className="table-down-main showMobile">
              <div className="table-down-s2" style={{ border: "none" }}>
                <div className="table-down-s1 fs-13">
                  <label className="table-down-l2">Total&nbsp;Qty:</label>
                  <span>{inputValues.TotalQty}</span>
                </div>
                <div className="table-down-s1 fs-13">
                  <label className="table-down-l2">Price:</label>
                  <span>
                    {parseFloat(inputValues.TotalPrice).toFixed(
                      currencyDecimalPlaces
                    )}
                  </span>
                </div>
                <div className="table-down-s1 fs-13">
                  <label className="table-down-l2">Disc:</label>
                  <span>
                    {/* {inputValues.} */}
                    {parseFloat(inputValues.TotalDisc).toFixed(
                      currencyDecimalPlaces
                    )}
                  </span>
                </div>
                <div
                  className="table-down-s1 fs-13"
                  style={{ paddingRight: "10px" }}
                >
                  <label className="table-down-l2">Amount:</label>
                  <span>
                    {/* {inputValues.} */}
                    {parseFloat(inputValues.TotalItemAmt).toFixed(
                      currencyDecimalPlaces
                    )}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="saveitemButton showMobile">
          <button className="addItemtnInsale" onClick={SaleItemAdd}>
            <i className="fa-solid fa-add"></i>
          </button>
        </div>
        <div className="DetailAndPagination">
          <div className="stock-label hideInMobile">
            <div>
              {stockQuantity !== null &&
                (stockQuantity === "Error" ? (
                  <label className="label-red fs-13">
                    &nbsp; Please Check Report Template Query
                  </label>
                ) : stockQuantity <= 0 ? (
                  <label className="label-red fs-13">
                    &nbsp; No stock available Avail Qty : {stockQuantity}
                  </label>
                ) : (
                  <label style={{ fontWeight: "bold" }} className="fs-13">
                    &nbsp; Available Qty : {stockQuantity}
                  </label>
                ))}
            </div>
          </div>

          <div
            className="table-down-main hideInMobile"
            // style={{ marginTop: "5px", marginBottom: "5px" }}
          >
            <div className="table-down-s2" style={{ border: "none" }}>
              {ShowCostPriceAndLandingPrice && (
                <>
                  <div className="table-down-s1 fs-13">
                    <label className="table-down-l2">Cost&nbsp;Price:</label>
                    <span>{inputValues.TotalQty}</span>
                  </div>
                  <div className="table-down-s1 fs-13">
                    <label className="table-down-l2">Landing&nbsp;Price:</label>
                    <span>{inputValues.TotalQty}</span>
                  </div>
                </>
              )}
              <div className="table-down-s1 fs-13">
                <label className="table-down-l2">Total&nbsp;Qty:</label>
                <span>{inputValues.TotalQty}</span>
              </div>
              <div className="table-down-s1 fs-13">
                <label className="table-down-l2">Price:</label>
                <span>
                  {parseFloat(inputValues.TotalPrice).toFixed(
                    currencyDecimalPlaces
                  )}
                </span>
              </div>
              <div className="table-down-s1 fs-13">
                <label className="table-down-l2">Disc:</label>
                <span>
                  {/* {inputValues.} */}
                  {parseFloat(inputValues.TotalDisc).toFixed(
                    currencyDecimalPlaces
                  )}
                </span>
              </div>
              <div className="table-down-s1 fs-13">
                <label className="table-down-l2">Amount:</label>
                <span>
                  {/* {inputValues.} */}
                  {parseFloat(inputValues.GrossAmt).toFixed(
                    currencyDecimalPlaces
                  )}
                </span>
              </div>
            </div>
            <tr className="pagination-tr">
              {/* <td style={{ display: "flex", alignItems: "center" }}>
                Number Of Rows
                <button
                  style={{ marginLeft: "5px" }}
                  className="PageNoPagination"
                >
                  {itemMasterRows && itemMasterRows.length}
                </button>
              </td> */}
              <td style={{ fontWeight: "600" }}>
                Product Per Page
                <select
                  className="salepgpagination-select"
                  name=""
                  id=""
                  value={ItemPerPage}
                  onChange={ChangeItemPerPage}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="300">300</option>
                  {/* <option value="500">500</option> */}
                </select>
              </td>
              <td onClick={PreviousPage}>
                <button className="salePrevNextBtn">
                  <i class="fa-solid fa-angle-left"></i>
                </button>
              </td>
              <td>
                <button className="PageNoPagination">{pageNo}</button>
              </td>
              <td onClick={NextPage}>
                <button className="salePrevNextBtn">
                  <i class="fa-solid fa-angle-right"></i>
                </button>
              </td>
            </tr>

            <div className="table-down-s2" style={{ border: "none" }}>
              <button className="btn-table2" onClick={handleAddRow}>
                <i className="fa-solid fa-square-plus sale-Invoice-plus-button"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/******************************************************/}
      {isModalOpen3 && (
        <div className="modal">
          <div className="ModalBoxProductSetting">
            <div className="modal-title">
              <h3 className="modal-h">Add Columns into Table</h3>
              <span className="close" onClick={hideModal3}>
                &times;
              </span>

              <div
                className="flex-end"
                style={{ paddingRight: "25px", width: "60%" }}
              >
                <button
                  id="step-5"
                  className="save-button-main-save"
                  onClick={SaveBtnClick}
                  style={{
                    width: "22%",
                    marginRight: "10px",
                    padding: "0px",
                    height: "35px",
                    fontWeight: "600",
                  }}
                >
                  Save
                  <i
                    className="fa-regular fa-floppy-disk im-icon-1"
                    style={{ color: "white" }}
                  ></i>
                </button>
              </div>
            </div>
            <div
              className="ModalContentModalSettingP"
              style={{ height: "450px", overflowY: "scroll" }}
            >
              <div className="gridview2">
                <div className=" ModalBoxInputM5">
                  <div className="input-box3 size-a1 ">
                    <input
                      onChange={(e) => {
                        handleHideAndShow_Column(e, 1, "Item Code");
                        appendValue(e);
                      }}
                      name="isInputVisible1"
                      autoComplete="off"
                      id="isInputVisible1"
                      checked={TransColumnCb.isInputVisible1}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible1"
                    >
                      {" "}
                      Item Code
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 1)}
                    />
                  </div>
                </div>
                <div className=" ModalBoxInputM5">
                  <div className="input-box3 size-a1 ">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 2, "Item Group")
                      }
                      name="isInputVisible2"
                      autoComplete="off"
                      id="isInputVisible2"
                      checked={TransColumnCb.isInputVisible2}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible2"
                    >
                      {" "}
                      Item Group
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 2)}
                    />
                  </div>
                </div>
                <div className=" ModalBoxInputM5">
                  <div className="input-box3 size-a1 ">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 3, "Item Name")
                      }
                      name="isInputVisible3"
                      autoComplete="off"
                      id="isInputVisible3"
                      checked={TransColumnCb.isInputVisible3}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible3"
                      className="modify_p_text_checkbox"
                      id="ItemName-w"
                    >
                      Item Name
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 3)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 4, "Master Description")
                      }
                      name="isInputVisible4"
                      autoComplete="off"
                      id="isInputVisible4"
                      checked={TransColumnCb.isInputVisible4}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible4"
                    >
                      {" "}
                      Master Description
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 4)}
                    />
                  </div>
                </div>
                <div className=" ModalBoxInputM5">
                  <div className="input-box3 size-a1 ">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 5, "Unit")}
                      name="isInputVisible5"
                      autoComplete="off"
                      id="isInputVisible5"
                      checked={TransColumnCb.isInputVisible5}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible5"
                    >
                      {" "}
                      Unit
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 5)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 6, "DIA")}
                      name="isInputVisible6"
                      autoComplete="off"
                      id="isInputVisible6"
                      checked={TransColumnCb.isInputVisible6}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible6"
                    >
                      {" "}
                      DIA
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 6)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 7, "EYE")}
                      name="isInputVisible7"
                      id="isInputVisible7"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible7}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible7"
                    >
                      {" "}
                      EYE
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 7)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 8, "SPH")}
                      name="isInputVisible8"
                      id="isInputVisible8"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible8}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible8"
                    >
                      {" "}
                      SPH
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 8)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 9, "CYL")}
                      name="isInputVisible9"
                      id="isInputVisible9"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible9}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible9"
                    >
                      {" "}
                      CYL
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 9)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 10, "AXIS")}
                      name="isInputVisible10"
                      id="isInputVisible10"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible10}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible10"
                    >
                      {" "}
                      AXIS
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 10)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 11, "ADD")}
                      name="isInputVisible11"
                      id="isInputVisible11"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible11}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible11"
                    >
                      {" "}
                      ADD
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 11)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 12, "Attribute 1")
                      }
                      name="isInputVisible12"
                      id="isInputVisible12"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible12}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible12"
                    >
                      Attribute 1
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 12)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 13, "Attribute 2")
                      }
                      name="isInputVisible13"
                      id="isInputVisible13"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible13}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible13"
                    >
                      {" "}
                      Attribute 2
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 13)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 14, "Attribute 3")
                      }
                      name="isInputVisible14"
                      id="isInputVisible14"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible14}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible14"
                    >
                      {" "}
                      Attribute 3
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 14)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 15, "Attribute 4")
                      }
                      name="isInputVisible15"
                      id="isInputVisible15"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible15}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible15"
                    >
                      {" "}
                      Attribute 4
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 15)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 16, "Attribute 5")
                      }
                      name="isInputVisible16"
                      id="isInputVisible16"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible16}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible16"
                    >
                      {" "}
                      Attribute 5
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 16)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 17, "Note 1")
                      }
                      name="isInputVisible17"
                      id="isInputVisible17"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible17}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible17"
                    >
                      {" "}
                      Note 1
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 17)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 18, "Note 2")
                      }
                      name="isInputVisible18"
                      id="isInputVisible18"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible18}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible18"
                    >
                      {" "}
                      Note 2
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 18)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 19, "Batch No")
                      }
                      name="isInputVisible19"
                      id="isInputVisible19"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible19}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible19"
                    >
                      {" "}
                      Batch No
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 19)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 20, "Mgf Date")
                      }
                      name="isInputVisible20"
                      id="isInputVisible20"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible20}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />

                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible20"
                    >
                      {" "}
                      Mgf Date
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 20)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5">
                  <div className="input-box3 size-a1 ">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 21, "Exp Date")
                      }
                      name="isInputVisible21"
                      id="isInputVisible21"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible21}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible21"
                    >
                      {" "}
                      Exp Date
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 21)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 22, "Qty")}
                      name="isInputVisible22"
                      id="isInputVisible22"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible22}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible22"
                    >
                      {" "}
                      Qty
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 22)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 23, "Free Qty")
                      }
                      name="isInputVisible23"
                      id="isInputVisible23"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible23}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible23"
                    >
                      {" "}
                      Free Qty
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 23)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 24, "Price")}
                      name="isInputVisible24"
                      id="isInputVisible24"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible24}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible24"
                    >
                      {" "}
                      Price
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 24)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 25, "Discount %")
                      }
                      name="isInputVisible25"
                      id="isInputVisible25"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible25}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />

                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible25"
                    >
                      {" "}
                      Discount %
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 25)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 26, "Double Discount %")
                      }
                      name="isInputVisible26"
                      id="isInputVisible26"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible26}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible26"
                    >
                      Double Discount %
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 26)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 27, "Discount Amt")
                      }
                      name="isInputVisible27"
                      id="isInputVisible27"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible27}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />

                    <label
                      className="modify_p_text_checkbox"
                      htmlFor="isInputVisible27"
                    >
                      {" "}
                      Discount Amt
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 27)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(
                          e,
                          29,
                          "Sale Price (Pur. Page)"
                        )
                      }
                      name="isInputVisible29"
                      id="isInputVisible29"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible29}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible29"
                      className="modify_p_text_checkbox"
                      style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      Sale Price (Pur. Page)
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 29)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(
                          e,
                          30,
                          "Sale Prof% (Pur. Page)"
                        )
                      }
                      name="isInputVisible30"
                      id="isInputVisible30"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible30}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible30"
                      className="modify_p_text_checkbox"
                      style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      Sale Prof% (Pur. Page)
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 30)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 31, "Mrp Price (Pur. Page)")
                      }
                      name="isInputVisible31"
                      id="isInputVisible31"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible31}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible31"
                      className="modify_p_text_checkbox"
                      style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      Mrp Price (Pur. Page)
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 31)}
                    />
                  </div>  
                </div>
                {/* <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 28, "Total Amt")
                      }
                      name="isInputVisible28"
                      id="isInputVisible28"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible28}
                      // disabled={true}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />

                    <label
                      htmlFor="isInputVisible28"
                      className="modify_p_text_checkbox"
                    >
                      {" "}
                      Total Amt
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 28)}
                    />
                  </div>
                </div> */}
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 32, "Brkr Name")
                      }
                      name="isInputVisible32"
                      autoComplete="off"
                      id="isInputVisible32"
                      checked={TransColumnCb.isInputVisible32}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible32"
                      className="modify_p_text_checkbox"
                      style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      Brkr Name
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 32)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 33, "Brkr%")}
                      name="isInputVisible33"
                      id="isInputVisible33"
                      autoComplete="off"
                      checked={TransColumnCb.isInputVisible33}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible33"
                      className="modify_p_text_checkbox"
                      style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      Brkr%
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 33)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 34, "Brkr Amt")
                      }
                      autoComplete="off"
                      name="isInputVisible34"
                      id="isInputVisible34"
                      checked={TransColumnCb.isInputVisible34}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible34"
                      className="modify_p_text_checkbox"
                      style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      Brkr Amt
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 34)}
                    />
                  </div>
                </div>
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 35, "CGST")}
                      autoComplete="off"
                      name="isInputVisible35"
                      id="isInputVisible35"
                      checked={TransColumnCb.isInputVisible35}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible35"
                      className="modify_p_text_checkbox"
                      // style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      CGST
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 35)}
                    />
                  </div>
                </div>{" "}
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 36, "IGST-VAT")
                      }
                      autoComplete="off"
                      name="isInputVisible36"
                      id="isInputVisible36"
                      checked={TransColumnCb.isInputVisible36}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible36"
                      className="modify_p_text_checkbox"
                      // style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      IGST / VAT
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 36)}
                    />
                  </div>
                </div>{" "}
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) => handleHideAndShow_Column(e, 37, "SGST")}
                      autoComplete="off"
                      name="isInputVisible37"
                      id="isInputVisible37"
                      checked={TransColumnCb.isInputVisible37}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible37"
                      className="modify_p_text_checkbox"
                      // style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      SGST
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 37)}
                    />
                  </div>
                </div>{" "}
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 38, "TaxRate")
                      }
                      autoComplete="off"
                      name="isInputVisible38"
                      id="isInputVisible38"
                      checked={TransColumnCb.isInputVisible38}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible38"
                      className="modify_p_text_checkbox"
                      // style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      TaxRate
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 38)}
                    />
                  </div>
                </div>{" "}
                <div className="ModalBoxInputM5 ">
                  <div className="input-box3 size-a1">
                    <input
                      onChange={(e) =>
                        handleHideAndShow_Column(e, 39, "TaxableAmount")
                      }
                      autoComplete="off"
                      name="isInputVisible39"
                      id="isInputVisible39"
                      checked={TransColumnCb.isInputVisible39}
                      style={{ boxShadow: "none" }}
                      className="modify_product_checkbox"
                      type="checkbox"
                    />
                    <label
                      htmlFor="isInputVisible39"
                      className="modify_p_text_checkbox"
                      // style={{ color: "teal", fontWeight: "600" }}
                    >
                      {" "}
                      Taxable Amount
                    </label>
                  </div>
                  <div className="ModalboxTitleInput">
                    <input
                      type="text"
                      className="ModalBoxWidthFix"
                      onChange={(e) => handleWidth_Column(e, 39)}
                    />
                  </div>
                </div>
                {(() => {
                  if (customfields.length !== 0) {
                    return customfields.map((fields, index) => (
                      <div className="ModalBoxInputM5 ">
                        <div className="input-box3 size-a1" key={fields.id}>
                          <input
                            onChange={(e) =>
                              handleHideAndShow_Column(
                                e,
                                index + 40,
                                fields.FieldName
                              )
                            }
                            name={`isInputVisible${fields.id + 39}`}
                            checked={
                              TransColumnCb[`isInputVisible${fields.id + 39}`]
                            }
                            style={{ boxShadow: "none" }}
                            className="modify_product_checkbox"
                            type="checkbox"
                          />
                          <label className="modify_p_text_checkbox">
                            {fields.FieldName}
                          </label>
                        </div>
                        <div className="ModalboxTitleInput ">
                          <input
                            type="text"
                            className="ModalBoxWidthFix"
                            onChange={(e) =>
                              handleWidth_Column(e, fields.id + 39)
                            }
                          />
                          <i
                            className="fa-solid fa-trash mt-1"
                            style={{ zIndex: "1", marginLeft: "50px" }}
                            onClick={() => deleteValueById(fields.id)}
                          ></i>
                        </div>
                      </div>
                    ));
                  }
                })()}
              </div>

              <div className="ModalBoxInputM5 " style={{ paddingLeft: "20px" }}>
                <div className="input-box3 size-a1">
                  <label className="modify_p_text_checkbox">
                    Set No Of Row In Page
                  </label>
                </div>
                <div className="ModalboxTitleInput">
                  <input
                    type="text"
                    className="ModalBoxWidthFix"
                    id="setNoOfRows"
                  />
                </div>
              </div>
              <div style={{ display: "none" }} id="inputField">
                <div className="flex-center">
                  <input
                    style={{ backgroundColor: "#0000001a", color: "white" }}
                    type="text"
                    id="CustomFieldInput"
                  />
                  <button className="Add_btn" onClick={customFieldAddBtn}>
                    Add
                  </button>
                </div>
              </div>
              <div className="flex-center">
                <label
                  style={{ color: "white", cursor: "pointer" }}
                  onClick={AddCustmField_clicked}
                >
                  + Add Custom Field into Table
                </label>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* **************************** Add New Modal ************** */}
      {AddNewModal && (
        <div className="modal">
          <div className="AddNewItem-modal increase_modal">
            <div className="modal-title">
              <span className="close_modal" onClick={closeAddItemModal}>
                &times;
              </span>
            </div>
            <div className="">
              <div className="tab-content-modal">
                <div className="company-info-top-modal control_flex_modal AddNewItem_scroll">
                  <AddNewItem />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {SaleItemAddPage && (
        <SaleItemAddPageComponent
          handleInputChange={handleInputChange}
          TransColumnCb={TransColumnCb}
          SaleItemAdd={CloswSaleItemAdd}
          showModal3={showModal3}
          appendValue={appendValue}
          itemMasterRows={itemMasterRows}
          onChangeProductSaveMethod={onChangeProductSaveMethod}
          handleProductRowKeyDown={handleProductRowKeyDown}
          mainPageInputRef={mainPageInputRef}
          nextCellRefsProduct={nextCellRefsProduct}
          handleProductNameChange={handleProductNameChange}
          handleKeyDown_ProductSuggestion={handleKeyDown_ProductSuggestion}
          itemMasterList={itemMasterList}
          itemRefs={itemRefs}
          handleProductSelection={handleProductSelection}
          suggestionBoxRef={suggestionBoxRef}
          handleAddRow={handleAddRow}
          handleDeleteRow={handleDeleteRow}
          indexToEdit={indexToEdit}
        />
      )}

      {lensPowerModalOpen && LensPowerItem != {} && (
        <MastersModalBox closeModal={closeLensPowerModal}>
          <LensitemDataModal
            closeModal={closeLensPowerModal}
            LensPowerItem={LensPowerItem}
            LensPowerItemRowindex={LensPowerItemRowindex}
            handleDeleteRow={handleDeleteRow}
            setItemMasterRows={setItemMasterRows}
            setChangeInData={setChangeInData}
            ReferenceNumber={ReferenceNumber}
            GetProductDataFunction={GetProductDataFunction}
            TransAccountId={TransAccountId}
          />
        </MastersModalBox>
      )}

      {openItemUploadCSV && (
        <CsvModalSaleInvoice
          onClose={() => setOpenItemUploadCSV(false)}
          ImportType={1}
          TransAccountId={TransAccountId}
          ReferenceNumber={ReferenceNumber}
          GetProductDataFunction={GetProductDataFunction}
          setChangeInData={setChangeInData}
        />
      )}

      <ThemeModalFristComponent
        isSliderOpen={isSliderOpen}
        SelectedItem={SelectedItem}
        setSelectedItem={setSelectedItem}
        id={SelectedItem.d2Id || SelectedItem.d2_Id}
        setShowFirstComponent={setShowFirstComponent}
        showFirstComponent={showFirstComponent}
        setSliderOpen={setSliderOpen}
        TransAccountId={TransAccountId}
        setItemMasterRows={setItemMasterRows}
        ReferenceNumber={ReferenceNumber}
        setChangeInData={setChangeInData}
        GetProductDataFunction={GetProductDataFunction}
        itemMasterRows={itemMasterRows}
        closeAddItemMOdal={closeAddItemMOdal}
        Code={Code}
        GenerateCode={GenerateCode}
        // lensTypeData={lensTypeData}
        // lensType={lensType}
        // eyePower={eyePower}
        FramePrice={Number(SelectedItem.salePrice)}
        // ref={modalRef}
        // AddInCart={AddInCart}
        // CodeGen={generate4DigitCode}
        // setHeaderName={setHeaderName}
      />
    </div>
  );
}


export default ProductList;